var $afe0828da796b709$export$2e2bcd8739ae039 = {
    createDocument: function createDocument(content) {
        // if (!content) {
        // 	throw new Error('No *.xml content')
        // }
        // A weird bug: it won't parse XML unless it's trimmed.
        // https://github.com/catamphetamine/read-excel-file/issues/21
        return new DOMParser().parseFromString(content.trim(), 'text/xml');
    }
};


// Uses an "async" function of the unzipper function
// just because it feels more correct to use it over the "sync" one
// because it isn't supposed to ever freeze the "main thread" (GUI).
//
// import unzipFromArrayBufferSync from '../zip/unzipFromArrayBufferSync.js'
// `fflate` readme is too complicated:
// https://github.com/101arrowz/fflate/issues/251
// I just used whatever approach seemed to work.
//
// It was a choice between "syncrhonous" (blocking) unzip via `unzipSync()`
// and "asynchronous" (non-blocking) unzip via `unzip()`.
//
// In the readme they say that using "asynchronous" API  will cause the compression or decompression
// run in a separate thread by using Web (or Node) Workers, so it won't block the main thread.
// Yet, they also say that there is an initial overhead to using workers of about 50ms for each
// asynchronous function. For small (under about 50kB) payloads, they say that the "asynchronous" API
// will be much slower compared to the "synchronous" one. However, when compressing larger files
// or multiple files at once, the "synchronous" API causes the main thread to hang for too long,
// and the "asynchronous" API is an order of magnitude better.
//
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $461bf5d8bd29e0d8$var$ch2 = {};
var $461bf5d8bd29e0d8$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($461bf5d8bd29e0d8$var$ch2[id] || ($461bf5d8bd29e0d8$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $461bf5d8bd29e0d8$var$u8 = Uint8Array, $461bf5d8bd29e0d8$var$u16 = Uint16Array, $461bf5d8bd29e0d8$var$i32 = Int32Array;
// fixed length extra bits
var $461bf5d8bd29e0d8$var$fleb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $461bf5d8bd29e0d8$var$fdeb = new $461bf5d8bd29e0d8$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $461bf5d8bd29e0d8$var$clim = new $461bf5d8bd29e0d8$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $461bf5d8bd29e0d8$var$freb = function(eb, start) {
    var b = new $461bf5d8bd29e0d8$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $461bf5d8bd29e0d8$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $461bf5d8bd29e0d8$var$_a = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fleb, 2), $461bf5d8bd29e0d8$var$fl = $461bf5d8bd29e0d8$var$_a.b, $461bf5d8bd29e0d8$var$revfl = $461bf5d8bd29e0d8$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$461bf5d8bd29e0d8$var$fl[28] = 258, $461bf5d8bd29e0d8$var$revfl[258] = 28;
var $461bf5d8bd29e0d8$var$_b = $461bf5d8bd29e0d8$var$freb($461bf5d8bd29e0d8$var$fdeb, 0), $461bf5d8bd29e0d8$var$fd = $461bf5d8bd29e0d8$var$_b.b, $461bf5d8bd29e0d8$var$revfd = $461bf5d8bd29e0d8$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $461bf5d8bd29e0d8$var$rev = new $461bf5d8bd29e0d8$var$u16(32768);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32768; ++$461bf5d8bd29e0d8$var$i){
    // reverse table algorithm from SO
    var $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$i & 0xAAAA) >> 1 | ($461bf5d8bd29e0d8$var$i & 0x5555) << 1;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xCCCC) >> 2 | ($461bf5d8bd29e0d8$var$x & 0x3333) << 2;
    $461bf5d8bd29e0d8$var$x = ($461bf5d8bd29e0d8$var$x & 0xF0F0) >> 4 | ($461bf5d8bd29e0d8$var$x & 0x0F0F) << 4;
    $461bf5d8bd29e0d8$var$rev[$461bf5d8bd29e0d8$var$i] = (($461bf5d8bd29e0d8$var$x & 0xFF00) >> 8 | ($461bf5d8bd29e0d8$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $461bf5d8bd29e0d8$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $461bf5d8bd29e0d8$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $461bf5d8bd29e0d8$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $461bf5d8bd29e0d8$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$461bf5d8bd29e0d8$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $461bf5d8bd29e0d8$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $461bf5d8bd29e0d8$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $461bf5d8bd29e0d8$var$flt = new $461bf5d8bd29e0d8$var$u8(288);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 144; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
for(var $461bf5d8bd29e0d8$var$i = 144; $461bf5d8bd29e0d8$var$i < 256; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 9;
for(var $461bf5d8bd29e0d8$var$i = 256; $461bf5d8bd29e0d8$var$i < 280; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 7;
for(var $461bf5d8bd29e0d8$var$i = 280; $461bf5d8bd29e0d8$var$i < 288; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$flt[$461bf5d8bd29e0d8$var$i] = 8;
// fixed distance tree
var $461bf5d8bd29e0d8$var$fdt = new $461bf5d8bd29e0d8$var$u8(32);
for(var $461bf5d8bd29e0d8$var$i = 0; $461bf5d8bd29e0d8$var$i < 32; ++$461bf5d8bd29e0d8$var$i)$461bf5d8bd29e0d8$var$fdt[$461bf5d8bd29e0d8$var$i] = 5;
// fixed length map
var $461bf5d8bd29e0d8$var$flm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 0), $461bf5d8bd29e0d8$var$flrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$flt, 9, 1);
// fixed distance map
var $461bf5d8bd29e0d8$var$fdm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 0), $461bf5d8bd29e0d8$var$fdrm = /*#__PURE__*/ $461bf5d8bd29e0d8$var$hMap($461bf5d8bd29e0d8$var$fdt, 5, 1);
// find max of array
var $461bf5d8bd29e0d8$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $461bf5d8bd29e0d8$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $461bf5d8bd29e0d8$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $461bf5d8bd29e0d8$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $461bf5d8bd29e0d8$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $461bf5d8bd29e0d8$var$u8(v.subarray(s, e));
};
var $461bf5d8bd29e0d8$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $461bf5d8bd29e0d8$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $461bf5d8bd29e0d8$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $461bf5d8bd29e0d8$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $461bf5d8bd29e0d8$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $461bf5d8bd29e0d8$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $461bf5d8bd29e0d8$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $461bf5d8bd29e0d8$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $461bf5d8bd29e0d8$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $461bf5d8bd29e0d8$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $461bf5d8bd29e0d8$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $461bf5d8bd29e0d8$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $461bf5d8bd29e0d8$var$flrm, dm = $461bf5d8bd29e0d8$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $461bf5d8bd29e0d8$var$bits(dat, pos, 31) + 257, hcLen = $461bf5d8bd29e0d8$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $461bf5d8bd29e0d8$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $461bf5d8bd29e0d8$var$u8(tl);
                // code length tree
                var clt = new $461bf5d8bd29e0d8$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$461bf5d8bd29e0d8$var$clim[i]] = $461bf5d8bd29e0d8$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $461bf5d8bd29e0d8$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $461bf5d8bd29e0d8$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$461bf5d8bd29e0d8$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $461bf5d8bd29e0d8$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $461bf5d8bd29e0d8$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $461bf5d8bd29e0d8$var$max(lt);
                // max dist bits
                dbt = $461bf5d8bd29e0d8$var$max(dt);
                lm = $461bf5d8bd29e0d8$var$hMap(lt, lbt, 1);
                dm = $461bf5d8bd29e0d8$var$hMap(dt, dbt, 1);
            } else $461bf5d8bd29e0d8$var$err(1);
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $461bf5d8bd29e0d8$var$err(0);
                break;
            }
            if (!c) $461bf5d8bd29e0d8$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $461bf5d8bd29e0d8$var$fleb[i];
                    add = $461bf5d8bd29e0d8$var$bits(dat, pos, (1 << b) - 1) + $461bf5d8bd29e0d8$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$461bf5d8bd29e0d8$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $461bf5d8bd29e0d8$var$err(3);
                pos += d & 15;
                var dt = $461bf5d8bd29e0d8$var$fd[dsym];
                if (dsym > 3) {
                    var b = $461bf5d8bd29e0d8$var$fdeb[dsym];
                    dt += $461bf5d8bd29e0d8$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $461bf5d8bd29e0d8$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $461bf5d8bd29e0d8$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $461bf5d8bd29e0d8$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $461bf5d8bd29e0d8$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $461bf5d8bd29e0d8$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $461bf5d8bd29e0d8$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $461bf5d8bd29e0d8$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $461bf5d8bd29e0d8$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $461bf5d8bd29e0d8$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $461bf5d8bd29e0d8$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $461bf5d8bd29e0d8$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $461bf5d8bd29e0d8$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($461bf5d8bd29e0d8$var$ln(n.l, l, d + 1), $461bf5d8bd29e0d8$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $461bf5d8bd29e0d8$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $461bf5d8bd29e0d8$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $461bf5d8bd29e0d8$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $461bf5d8bd29e0d8$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $461bf5d8bd29e0d8$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $461bf5d8bd29e0d8$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $461bf5d8bd29e0d8$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $461bf5d8bd29e0d8$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $461bf5d8bd29e0d8$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $461bf5d8bd29e0d8$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $461bf5d8bd29e0d8$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $461bf5d8bd29e0d8$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $461bf5d8bd29e0d8$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$461bf5d8bd29e0d8$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $461bf5d8bd29e0d8$var$clen(lf, $461bf5d8bd29e0d8$var$flt) + $461bf5d8bd29e0d8$var$clen(df, $461bf5d8bd29e0d8$var$fdt) + eb;
    var dtlen = $461bf5d8bd29e0d8$var$clen(lf, dlt) + $461bf5d8bd29e0d8$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $461bf5d8bd29e0d8$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $461bf5d8bd29e0d8$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $461bf5d8bd29e0d8$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $461bf5d8bd29e0d8$var$hMap(dlt, mlb, 0), ll = dlt, dm = $461bf5d8bd29e0d8$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $461bf5d8bd29e0d8$var$hMap(lct, mlcb, 0);
        $461bf5d8bd29e0d8$var$wbits(out, p, nlc - 257);
        $461bf5d8bd29e0d8$var$wbits(out, p + 5, ndc - 1);
        $461bf5d8bd29e0d8$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$461bf5d8bd29e0d8$var$wbits(out, p + 3 * i, lct[$461bf5d8bd29e0d8$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $461bf5d8bd29e0d8$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $461bf5d8bd29e0d8$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $461bf5d8bd29e0d8$var$flm, ll = $461bf5d8bd29e0d8$var$flt, dm = $461bf5d8bd29e0d8$var$fdm, dl = $461bf5d8bd29e0d8$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $461bf5d8bd29e0d8$var$wbits(out, p, sym >> 23 & 31), p += $461bf5d8bd29e0d8$var$fleb[len];
            var dst = sym & 31;
            $461bf5d8bd29e0d8$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $461bf5d8bd29e0d8$var$wbits16(out, p, sym >> 5 & 8191), p += $461bf5d8bd29e0d8$var$fdeb[dst];
        } else $461bf5d8bd29e0d8$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $461bf5d8bd29e0d8$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $461bf5d8bd29e0d8$var$deo = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $461bf5d8bd29e0d8$var$et = /*#__PURE__*/ new $461bf5d8bd29e0d8$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $461bf5d8bd29e0d8$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $461bf5d8bd29e0d8$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $461bf5d8bd29e0d8$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $461bf5d8bd29e0d8$var$u16(32768), head = st.h || new $461bf5d8bd29e0d8$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $461bf5d8bd29e0d8$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $461bf5d8bd29e0d8$var$u16(288), df = new $461bf5d8bd29e0d8$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $461bf5d8bd29e0d8$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $461bf5d8bd29e0d8$var$revfl[l] << 18 | $461bf5d8bd29e0d8$var$revfd[d];
                    var lin = $461bf5d8bd29e0d8$var$revfl[l] & 31, din = $461bf5d8bd29e0d8$var$revfd[d] & 31;
                    eb += $461bf5d8bd29e0d8$var$fleb[lin] + $461bf5d8bd29e0d8$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $461bf5d8bd29e0d8$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $461bf5d8bd29e0d8$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $461bf5d8bd29e0d8$var$slc(o, 0, pre + $461bf5d8bd29e0d8$var$shft(pos) + post);
};
// CRC32 table
var $461bf5d8bd29e0d8$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $461bf5d8bd29e0d8$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $461bf5d8bd29e0d8$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $461bf5d8bd29e0d8$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $461bf5d8bd29e0d8$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $461bf5d8bd29e0d8$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $461bf5d8bd29e0d8$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $461bf5d8bd29e0d8$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $461bf5d8bd29e0d8$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $461bf5d8bd29e0d8$var$ch = [];
// clone bufs
var $461bf5d8bd29e0d8$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $461bf5d8bd29e0d8$var$wrkr = function(fns, init, id, cb) {
    if (!$461bf5d8bd29e0d8$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $461bf5d8bd29e0d8$var$wcln(fns[i], fnStr, td_1);
        $461bf5d8bd29e0d8$var$ch[id] = {
            c: $461bf5d8bd29e0d8$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $461bf5d8bd29e0d8$var$mrg({}, $461bf5d8bd29e0d8$var$ch[id].e);
    return $461bf5d8bd29e0d8$var$wk($461bf5d8bd29e0d8$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $461bf5d8bd29e0d8$var$cbfs(td), cb);
};
// base async inflate fn
var $461bf5d8bd29e0d8$var$bInflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$fl,
        $461bf5d8bd29e0d8$var$fd,
        $461bf5d8bd29e0d8$var$flrm,
        $461bf5d8bd29e0d8$var$fdrm,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$ec,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$max,
        $461bf5d8bd29e0d8$var$bits,
        $461bf5d8bd29e0d8$var$bits16,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$err,
        $461bf5d8bd29e0d8$var$inflt,
        $461bf5d8bd29e0d8$export$90366d8b308ba94a,
        $461bf5d8bd29e0d8$var$pbf,
        $461bf5d8bd29e0d8$var$gopt
    ];
};
var $461bf5d8bd29e0d8$var$bDflt = function() {
    return [
        $461bf5d8bd29e0d8$var$u8,
        $461bf5d8bd29e0d8$var$u16,
        $461bf5d8bd29e0d8$var$i32,
        $461bf5d8bd29e0d8$var$fleb,
        $461bf5d8bd29e0d8$var$fdeb,
        $461bf5d8bd29e0d8$var$clim,
        $461bf5d8bd29e0d8$var$revfl,
        $461bf5d8bd29e0d8$var$revfd,
        $461bf5d8bd29e0d8$var$flm,
        $461bf5d8bd29e0d8$var$flt,
        $461bf5d8bd29e0d8$var$fdm,
        $461bf5d8bd29e0d8$var$fdt,
        $461bf5d8bd29e0d8$var$rev,
        $461bf5d8bd29e0d8$var$deo,
        $461bf5d8bd29e0d8$var$et,
        $461bf5d8bd29e0d8$var$hMap,
        $461bf5d8bd29e0d8$var$wbits,
        $461bf5d8bd29e0d8$var$wbits16,
        $461bf5d8bd29e0d8$var$hTree,
        $461bf5d8bd29e0d8$var$ln,
        $461bf5d8bd29e0d8$var$lc,
        $461bf5d8bd29e0d8$var$clen,
        $461bf5d8bd29e0d8$var$wfblk,
        $461bf5d8bd29e0d8$var$wblk,
        $461bf5d8bd29e0d8$var$shft,
        $461bf5d8bd29e0d8$var$slc,
        $461bf5d8bd29e0d8$var$dflt,
        $461bf5d8bd29e0d8$var$dopt,
        $461bf5d8bd29e0d8$export$21533ff51b8a0b4a,
        $461bf5d8bd29e0d8$var$pbf
    ];
};
// gzip extra
var $461bf5d8bd29e0d8$var$gze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzh,
        $461bf5d8bd29e0d8$var$gzhl,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$crc,
        $461bf5d8bd29e0d8$var$crct
    ];
};
// gunzip extra
var $461bf5d8bd29e0d8$var$guze = function() {
    return [
        $461bf5d8bd29e0d8$var$gzs,
        $461bf5d8bd29e0d8$var$gzl
    ];
};
// zlib extra
var $461bf5d8bd29e0d8$var$zle = function() {
    return [
        $461bf5d8bd29e0d8$var$zlh,
        $461bf5d8bd29e0d8$var$wbytes,
        $461bf5d8bd29e0d8$var$adler
    ];
};
// unzlib extra
var $461bf5d8bd29e0d8$var$zule = function() {
    return [
        $461bf5d8bd29e0d8$var$zls
    ];
};
// post buf
var $461bf5d8bd29e0d8$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $461bf5d8bd29e0d8$var$gopt = function(o) {
    return o && {
        out: o.size && new $461bf5d8bd29e0d8$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $461bf5d8bd29e0d8$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $461bf5d8bd29e0d8$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $461bf5d8bd29e0d8$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $461bf5d8bd29e0d8$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (t) strm.ondata($461bf5d8bd29e0d8$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $461bf5d8bd29e0d8$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $461bf5d8bd29e0d8$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $461bf5d8bd29e0d8$var$b8 = function(d, b) {
    return $461bf5d8bd29e0d8$var$b4(d, b) + $461bf5d8bd29e0d8$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $461bf5d8bd29e0d8$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $461bf5d8bd29e0d8$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $461bf5d8bd29e0d8$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $461bf5d8bd29e0d8$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $461bf5d8bd29e0d8$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $461bf5d8bd29e0d8$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $461bf5d8bd29e0d8$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $461bf5d8bd29e0d8$var$adler();
        h.p(o.dictionary);
        $461bf5d8bd29e0d8$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $461bf5d8bd29e0d8$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $461bf5d8bd29e0d8$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $461bf5d8bd29e0d8$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($461bf5d8bd29e0d8$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $461bf5d8bd29e0d8$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.s.l) $461bf5d8bd29e0d8$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $461bf5d8bd29e0d8$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$ae157b6234afe138(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $461bf5d8bd29e0d8$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(data, opts) {
    return $461bf5d8bd29e0d8$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $461bf5d8bd29e0d8$var$u8(32768);
        this.p = new $461bf5d8bd29e0d8$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $461bf5d8bd29e0d8$var$inflt(this.p, this.s, this.o);
        this.ondata($461bf5d8bd29e0d8$var$slc(dt, bts, this.s.b), this.d);
        this.o = $461bf5d8bd29e0d8$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $461bf5d8bd29e0d8$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$90366d8b308ba94a(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.l = 0;
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && $461bf5d8bd29e0d8$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$gzh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 8, this.c.d()), $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $461bf5d8bd29e0d8$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$gze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$8e4b66d280bf8342
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$8e4b66d280bf8342(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $461bf5d8bd29e0d8$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$gze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $461bf5d8bd29e0d8$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $461bf5d8bd29e0d8$var$crc(), l = data.length;
    c.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, $461bf5d8bd29e0d8$var$gzhl(opts), 8), s = d.length;
    return $461bf5d8bd29e0d8$var$gzh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, s - 8, c.d()), $461bf5d8bd29e0d8$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $461bf5d8bd29e0d8$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $461bf5d8bd29e0d8$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $461bf5d8bd29e0d8$var$u8(0);
            this.push(new $461bf5d8bd29e0d8$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $461bf5d8bd29e0d8$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$guze,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$4cb607de6db70415
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$guze,
        function() {
            return [
                $461bf5d8bd29e0d8$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) {
    var st = $461bf5d8bd29e0d8$var$gzs(data);
    if (st + 8 > data.length) $461bf5d8bd29e0d8$var$err(6, 'invalid gzip data');
    return $461bf5d8bd29e0d8$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $461bf5d8bd29e0d8$var$u8($461bf5d8bd29e0d8$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $461bf5d8bd29e0d8$var$adler();
        this.v = 1;
        $461bf5d8bd29e0d8$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $461bf5d8bd29e0d8$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $461bf5d8bd29e0d8$var$zlh(raw, this.o), this.v = 0;
        if (f) $461bf5d8bd29e0d8$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $461bf5d8bd29e0d8$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $461bf5d8bd29e0d8$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bDflt,
            $461bf5d8bd29e0d8$var$zle,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$ae157b6234afe138,
                    $461bf5d8bd29e0d8$export$4187ccf2467013b9
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$4187ccf2467013b9(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $461bf5d8bd29e0d8$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bDflt,
        $461bf5d8bd29e0d8$var$zle,
        function() {
            return [
                $461bf5d8bd29e0d8$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $461bf5d8bd29e0d8$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $461bf5d8bd29e0d8$var$adler();
    a.p(data);
    var d = $461bf5d8bd29e0d8$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $461bf5d8bd29e0d8$var$zlh(d, opts), $461bf5d8bd29e0d8$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($461bf5d8bd29e0d8$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $461bf5d8bd29e0d8$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $461bf5d8bd29e0d8$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $461bf5d8bd29e0d8$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $461bf5d8bd29e0d8$var$astrmify([
            $461bf5d8bd29e0d8$var$bInflt,
            $461bf5d8bd29e0d8$var$zule,
            function() {
                return [
                    $461bf5d8bd29e0d8$var$astrm,
                    $461bf5d8bd29e0d8$export$d1de70a877d6e43c,
                    $461bf5d8bd29e0d8$export$af2424f875ff1b17
                ];
            }
        ], this, $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $461bf5d8bd29e0d8$export$af2424f875ff1b17(ev.data);
            onmessage = $461bf5d8bd29e0d8$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return $461bf5d8bd29e0d8$var$cbify(data, opts, [
        $461bf5d8bd29e0d8$var$bInflt,
        $461bf5d8bd29e0d8$var$zule,
        function() {
            return [
                $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $461bf5d8bd29e0d8$var$pbf($461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(ev.data[0], $461bf5d8bd29e0d8$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts) {
    return $461bf5d8bd29e0d8$var$inflt(data.subarray($461bf5d8bd29e0d8$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $461bf5d8bd29e0d8$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $461bf5d8bd29e0d8$export$4cb607de6db70415;
        this.I = $461bf5d8bd29e0d8$export$d1de70a877d6e43c;
        this.Z = $461bf5d8bd29e0d8$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $461bf5d8bd29e0d8$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $461bf5d8bd29e0d8$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $461bf5d8bd29e0d8$export$d5adcdd968132151;
        this.I = $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc;
        this.Z = $461bf5d8bd29e0d8$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $461bf5d8bd29e0d8$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $461bf5d8bd29e0d8$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$cae1ce83fe4a1782(data, opts, cb) : $461bf5d8bd29e0d8$export$ca7cbb494e731274(data, opts, cb);
}
function $461bf5d8bd29e0d8$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $461bf5d8bd29e0d8$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $461bf5d8bd29e0d8$export$90366d8b308ba94a(data, opts) : $461bf5d8bd29e0d8$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $461bf5d8bd29e0d8$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $461bf5d8bd29e0d8$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $461bf5d8bd29e0d8$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $461bf5d8bd29e0d8$var$u8(0),
                op
            ];
            $461bf5d8bd29e0d8$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $461bf5d8bd29e0d8$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $461bf5d8bd29e0d8$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $461bf5d8bd29e0d8$var$tds = 0;
try {
    $461bf5d8bd29e0d8$var$td.decode($461bf5d8bd29e0d8$var$et, {
        stream: true
    });
    $461bf5d8bd29e0d8$var$tds = 1;
} catch (e) {}
// decode UTF8
var $461bf5d8bd29e0d8$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $461bf5d8bd29e0d8$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $461bf5d8bd29e0d8$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($461bf5d8bd29e0d8$var$tds) this.t = new TextDecoder();
        else this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $461bf5d8bd29e0d8$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        var dat = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $461bf5d8bd29e0d8$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $461bf5d8bd29e0d8$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        if (this.d) $461bf5d8bd29e0d8$var$err(4);
        this.ondata($461bf5d8bd29e0d8$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $461bf5d8bd29e0d8$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($461bf5d8bd29e0d8$var$te) return $461bf5d8bd29e0d8$var$te.encode(str);
    var l = str.length;
    var ar = new $461bf5d8bd29e0d8$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $461bf5d8bd29e0d8$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $461bf5d8bd29e0d8$var$slc(ar, 0, ai);
}
function $461bf5d8bd29e0d8$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($461bf5d8bd29e0d8$var$td) return $461bf5d8bd29e0d8$var$td.decode(dat);
    else {
        var _a = $461bf5d8bd29e0d8$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $461bf5d8bd29e0d8$var$err(8);
        return s;
    }
}
// deflate bit flag
var $461bf5d8bd29e0d8$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $461bf5d8bd29e0d8$var$slzh = function(d, b) {
    return b + 30 + $461bf5d8bd29e0d8$var$b2(d, b + 26) + $461bf5d8bd29e0d8$var$b2(d, b + 28);
};
// read zip header
var $461bf5d8bd29e0d8$var$zh = function(d, b, z) {
    var fnl = $461bf5d8bd29e0d8$var$b2(d, b + 28), fn = $461bf5d8bd29e0d8$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($461bf5d8bd29e0d8$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $461bf5d8bd29e0d8$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $461bf5d8bd29e0d8$var$z64e(d, es) : [
        bs,
        $461bf5d8bd29e0d8$var$b4(d, b + 24),
        $461bf5d8bd29e0d8$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $461bf5d8bd29e0d8$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $461bf5d8bd29e0d8$var$b2(d, b + 30) + $461bf5d8bd29e0d8$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $461bf5d8bd29e0d8$var$z64e = function(d, b) {
    for(; $461bf5d8bd29e0d8$var$b2(d, b) != 1; b += 4 + $461bf5d8bd29e0d8$var$b2(d, b + 2));
    return [
        $461bf5d8bd29e0d8$var$b8(d, b + 12),
        $461bf5d8bd29e0d8$var$b8(d, b + 4),
        $461bf5d8bd29e0d8$var$b8(d, b + 20)
    ];
};
// extra field length
var $461bf5d8bd29e0d8$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $461bf5d8bd29e0d8$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $461bf5d8bd29e0d8$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $461bf5d8bd29e0d8$var$exfl(ex);
    $461bf5d8bd29e0d8$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $461bf5d8bd29e0d8$var$err(10);
    $461bf5d8bd29e0d8$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, f.crc);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 8, f.size);
    }
    $461bf5d8bd29e0d8$var$wbytes(d, b + 12, fl);
    $461bf5d8bd29e0d8$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $461bf5d8bd29e0d8$var$wbytes(d, b, col);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 6, f.attrs);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $461bf5d8bd29e0d8$var$wbytes(d, b, +k);
        $461bf5d8bd29e0d8$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $461bf5d8bd29e0d8$var$wzf = function(o, b, c, d, e) {
    $461bf5d8bd29e0d8$var$wbytes(o, b, 0x6054B50); // skip disk
    $461bf5d8bd29e0d8$var$wbytes(o, b + 8, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 10, c);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 12, d);
    $461bf5d8bd29e0d8$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $461bf5d8bd29e0d8$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $461bf5d8bd29e0d8$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $461bf5d8bd29e0d8$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.call(this, filename);
        this.d = new $461bf5d8bd29e0d8$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $461bf5d8bd29e0d8$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $461bf5d8bd29e0d8$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $461bf5d8bd29e0d8$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $461bf5d8bd29e0d8$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $461bf5d8bd29e0d8$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($461bf5d8bd29e0d8$var$err(11, 0, 1), null, false);
            var header = new $461bf5d8bd29e0d8$var$u8(hl_1);
            $461bf5d8bd29e0d8$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $461bf5d8bd29e0d8$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $461bf5d8bd29e0d8$var$u8(16);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 0, 0x8074B50);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 4, file.crc);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 8, cl_1);
                        $461bf5d8bd29e0d8$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($461bf5d8bd29e0d8$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $461bf5d8bd29e0d8$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $461bf5d8bd29e0d8$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $461bf5d8bd29e0d8$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $461bf5d8bd29e0d8$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var r = {};
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $461bf5d8bd29e0d8$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $461bf5d8bd29e0d8$var$crc(), size = file.length;
        c.p(file);
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $461bf5d8bd29e0d8$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($461bf5d8bd29e0d8$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($461bf5d8bd29e0d8$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $461bf5d8bd29e0d8$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $461bf5d8bd29e0d8$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $461bf5d8bd29e0d8$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $461bf5d8bd29e0d8$var$exfl(p.extra);
        if (s > 65535) $461bf5d8bd29e0d8$var$err(11);
        var d = compression ? $461bf5d8bd29e0d8$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $461bf5d8bd29e0d8$var$crc();
        c.p(file);
        files.push($461bf5d8bd29e0d8$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $461bf5d8bd29e0d8$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $461bf5d8bd29e0d8$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $461bf5d8bd29e0d8$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $461bf5d8bd29e0d8$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $461bf5d8bd29e0d8$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $461bf5d8bd29e0d8$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $461bf5d8bd29e0d8$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $461bf5d8bd29e0d8$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $461bf5d8bd29e0d8$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $461bf5d8bd29e0d8$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $461bf5d8bd29e0d8$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $461bf5d8bd29e0d8$export$93f81d5bbbb7c6bf
        };
        this.p = $461bf5d8bd29e0d8$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $461bf5d8bd29e0d8$var$err(5);
        if (!this.p) $461bf5d8bd29e0d8$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $461bf5d8bd29e0d8$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $461bf5d8bd29e0d8$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $461bf5d8bd29e0d8$var$b2(buf, i + 6), cmp_1 = $461bf5d8bd29e0d8$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $461bf5d8bd29e0d8$var$b2(buf, i + 26), es = $461bf5d8bd29e0d8$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 18), su_1 = $461bf5d8bd29e0d8$var$b4(buf, i + 22);
                        var fn_1 = $461bf5d8bd29e0d8$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $461bf5d8bd29e0d8$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $461bf5d8bd29e0d8$var$err(5);
                                if (!sc_1) file_1.ondata(null, $461bf5d8bd29e0d8$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($461bf5d8bd29e0d8$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $461bf5d8bd29e0d8$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($461bf5d8bd29e0d8$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $461bf5d8bd29e0d8$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $461bf5d8bd29e0d8$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $461bf5d8bd29e0d8$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $461bf5d8bd29e0d8$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $461bf5d8bd29e0d8$var$mt(function() {
            cb(a, b);
        });
    };
    $461bf5d8bd29e0d8$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($461bf5d8bd29e0d8$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
            z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
                o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $461bf5d8bd29e0d8$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $461bf5d8bd29e0d8$export$90366d8b308ba94a(infl, {
                            out: new $461bf5d8bd29e0d8$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($461bf5d8bd29e0d8$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $461bf5d8bd29e0d8$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $461bf5d8bd29e0d8$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $461bf5d8bd29e0d8$var$err(13);
    var c = $461bf5d8bd29e0d8$var$b2(data, e + 8);
    if (!c) return {};
    var o = $461bf5d8bd29e0d8$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $461bf5d8bd29e0d8$var$b4(data, e - 12);
        z = $461bf5d8bd29e0d8$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $461bf5d8bd29e0d8$var$b4(data, ze + 32);
            o = $461bf5d8bd29e0d8$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $461bf5d8bd29e0d8$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $461bf5d8bd29e0d8$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $461bf5d8bd29e0d8$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $461bf5d8bd29e0d8$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $461bf5d8bd29e0d8$var$u8(su)
            });
            else $461bf5d8bd29e0d8$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}


function $ec7a95dc433ac559$export$2e2bcd8739ae039(input, options) {
    return $ec7a95dc433ac559$export$eb7d40f6e47f0f46(input, options, $ec7a95dc433ac559$var$unzipAsync, true);
}
function $ec7a95dc433ac559$export$eb7d40f6e47f0f46(input) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _filter = _ref.filter;
    var unzip = arguments.length > 2 ? arguments[2] : undefined;
    var isAsync = arguments.length > 3 ? arguments[3] : undefined;
    // Read the `.zip` archive.
    // `result` is either `object` or `Promise<object>`
    return unzip(new Uint8Array(input), {
        // Ignore certain types of files.
        filter: function filter(file) {
            if (_filter) return _filter({
                path: file.name
            });
            return true;
        }
    });
}
function $ec7a95dc433ac559$var$unzipAsync(archive) {
    return new Promise(function(resolve, reject) {
        // `unzip()` will resort to "synchronous" decompression in two edge cases:
        // * When the archive size is less than `512KB`.
        // * When the data is barely compressed, i.e. the compression ratio is less than 20% reduction in size.
        (0, $461bf5d8bd29e0d8$export$23c8d3f8757cab88)(archive, function(error, files) {
            if (error) reject(error);
            else resolve(files);
        });
    });
}



function $d9b9ae8266de5925$export$2e2bcd8739ae039(entries) {
    var convertedEntries = {};
    for(var _i = 0, _Object$keys = Object.keys(entries); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        convertedEntries[key] = (0, $461bf5d8bd29e0d8$export$adb211f8cb999894)(entries[key]);
    }
    return convertedEntries;
}


// An `.xlsx` `.zip` archive could contain all kinds of files,
// such as `.bin` printer settings or `.png` images, etc.
//
// Because `read-excel-file` doesn't support returning any of those types of data,
// there's no need to read those files from the `.xlsx` `.zip` archive,
// optimizing the unpacking process a little bit.
//
function $21b55122de8ba859$export$2e2bcd8739ae039(_ref) {
    var path = _ref.path;
    return path.endsWith('.xml') || path.endsWith('.xml.rels');
}


function $f1382763c1512ed2$export$2e2bcd8739ae039(input) {
    if (input instanceof File || input instanceof Blob) return input.arrayBuffer().then($f1382763c1512ed2$var$getResultFromArrayBuffer);
    return Promise.resolve(input).then($f1382763c1512ed2$var$getResultFromArrayBuffer);
}
function $f1382763c1512ed2$var$getResultFromArrayBuffer(arrayBuffer) {
    return (0, $ec7a95dc433ac559$export$2e2bcd8739ae039)(arrayBuffer, {
        filter: (0, $21b55122de8ba859$export$2e2bcd8739ae039)
    }).then((0, $d9b9ae8266de5925$export$2e2bcd8739ae039));
} // function getResultFromArrayBufferSync(arrayBuffer) {
 //  const result = unzipFromArrayBufferSync(arrayBuffer, { filter: filterZipArchiveEntry })
 // 	return convertValuesFromUint8ArraysToStrings(result)
 // }


function $b77897ce6f4fce6e$export$8163adcb8ffddfe9(node, tagName) {
    var i = 0;
    while(i < node.childNodes.length){
        var childNode = node.childNodes[i];
        // `nodeType: 1` means "Element".
        // https://www.w3schools.com/xml/prop_element_nodetype.asp
        if (childNode.nodeType === 1 && $b77897ce6f4fce6e$export$cc701a2c22ef3722(childNode) === tagName) return childNode;
        i++;
    }
}
function $b77897ce6f4fce6e$export$f94ca194e830789c(node, tagName) {
    var results = [];
    var i = 0;
    while(i < node.childNodes.length){
        var childNode = node.childNodes[i];
        // `nodeType: 1` means "Element".
        // https://www.w3schools.com/xml/prop_element_nodetype.asp
        if (childNode.nodeType === 1 && $b77897ce6f4fce6e$export$cc701a2c22ef3722(childNode) === tagName) results.push(childNode);
        i++;
    }
    return results;
}
function $b77897ce6f4fce6e$export$4b80e395e36b5a56(node, tagName, func) {
    // if (typeof tagName === 'function') {
    // 	func = tagName
    // 	tagName = undefined
    // }
    var i = 0;
    while(i < node.childNodes.length){
        var childNode = node.childNodes[i];
        if (tagName) // `nodeType: 1` means "Element".
        // https://www.w3schools.com/xml/prop_element_nodetype.asp
        {
            if (childNode.nodeType === 1 && $b77897ce6f4fce6e$export$cc701a2c22ef3722(childNode) === tagName) func(childNode, i);
        } else func(childNode, i);
        i++;
    }
}
function $b77897ce6f4fce6e$export$871de8747c9eaa88(node, tagName, func) {
    var results = [];
    $b77897ce6f4fce6e$export$4b80e395e36b5a56(node, tagName, function(node, i) {
        results.push(func(node, i));
    });
    return results;
}
var $b77897ce6f4fce6e$var$NAMESPACE_REG_EXP = /.+\:/;
function $b77897ce6f4fce6e$export$cc701a2c22ef3722(element) {
    // For some weird reason, if an element is declared as,
    // for example, `<x:sheets/>`, then its `.tagName` will be
    // "x:sheets" instead of just "sheets".
    // https://gitlab.com/catamphetamine/read-excel-file/-/issues/25
    // Its not clear how to tell it to ignore any namespaces
    // when getting `.tagName`, so just replacing anything
    // before a colon, if any.
    return element.tagName.replace($b77897ce6f4fce6e$var$NAMESPACE_REG_EXP, '');
}
function $b77897ce6f4fce6e$export$45a5e7f76e0caa8d(node) {
    // `nodeType: 1` means "Element".
    // https://www.w3schools.com/xml/prop_element_nodetype.asp
    return node.nodeType === 1;
}
function $b77897ce6f4fce6e$export$d8382c15efe200bb(element) {
    var i = 0;
    while(i < element.childNodes.length){
        if ($b77897ce6f4fce6e$export$45a5e7f76e0caa8d(element.childNodes[i])) return element.childNodes[i];
        i++;
    }
}
function $b77897ce6f4fce6e$export$441f600056df684b(node) {
    // `nodeType: 1` means "Element".
    // https://www.w3schools.com/xml/prop_element_nodetype.asp
    if (node.nodeType !== 1) return node.textContent;
    var xml = '<' + $b77897ce6f4fce6e$export$cc701a2c22ef3722(node);
    var j = 0;
    while(j < node.attributes.length){
        xml += ' ' + node.attributes[j].name + '=' + '"' + node.attributes[j].value + '"';
        j++;
    }
    xml += '>';
    var i = 0;
    while(i < node.childNodes.length){
        xml += $b77897ce6f4fce6e$export$441f600056df684b(node.childNodes[i]);
        i++;
    }
    xml += '</' + $b77897ce6f4fce6e$export$cc701a2c22ef3722(node) + '>';
    return xml;
}


function $d7aca80854b84493$export$1c12da66f9764822(document) {
    var worksheet = document.documentElement;
    var sheetData = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(worksheet, 'sheetData');
    var cells = [];
    (0, $b77897ce6f4fce6e$export$4b80e395e36b5a56)(sheetData, 'row', function(row) {
        (0, $b77897ce6f4fce6e$export$4b80e395e36b5a56)(row, 'c', function(cell) {
            cells.push(cell);
        });
    });
    return cells;
}
function $d7aca80854b84493$export$8f60a965694bd139(document) {
    var worksheet = document.documentElement;
    var mergedCells = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(worksheet, 'mergeCells');
    var mergedCellsInfo = [];
    if (mergedCells) (0, $b77897ce6f4fce6e$export$4b80e395e36b5a56)(mergedCells, 'mergeCell', function(mergedCell) {
        mergedCellsInfo.push(mergedCell.getAttribute('ref'));
    });
    return mergedCellsInfo;
}
function $d7aca80854b84493$export$96e987a410e855d8(document, element) {
    return (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(element, 'v');
}
function $d7aca80854b84493$export$78a3f2230f4dec6f(document, element) {
    // It seems as if in some weirdly-output "*.xlsx" files
    // there're non-element nodes of some weird nature.
    // https://gitlab.com/catamphetamine/read-excel-file/-/issues/109
    // This code filters out such weird non-element nodes.
    var firstElementChild = (0, $b77897ce6f4fce6e$export$d8382c15efe200bb)(element);
    if (firstElementChild && (0, $b77897ce6f4fce6e$export$cc701a2c22ef3722)(firstElementChild) === 'is') {
        var firstElementChildFirstElementChild = (0, $b77897ce6f4fce6e$export$d8382c15efe200bb)(firstElementChild);
        if (firstElementChildFirstElementChild && (0, $b77897ce6f4fce6e$export$cc701a2c22ef3722)(firstElementChildFirstElementChild) === 't') return firstElementChildFirstElementChild.textContent;
    }
}
function $d7aca80854b84493$export$d1aa971bf69c7e87(document) {
    var worksheet = document.documentElement;
    var dimensions = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(worksheet, 'dimension');
    if (dimensions) return dimensions.getAttribute('ref');
}
function $d7aca80854b84493$export$bff8031d86bb089(document) {
    var styleSheet = document.documentElement;
    var cellStyleXfs = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(styleSheet, 'cellStyleXfs');
    if (cellStyleXfs) return (0, $b77897ce6f4fce6e$export$f94ca194e830789c)(cellStyleXfs, 'xf');
    return [];
}
function $d7aca80854b84493$export$cbecc5fa687c7fad(document) {
    var styleSheet = document.documentElement;
    var cellXfs = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(styleSheet, 'cellXfs');
    if (!cellXfs) return [];
    return (0, $b77897ce6f4fce6e$export$f94ca194e830789c)(cellXfs, 'xf');
}
function $d7aca80854b84493$export$d23f63acf2d35cbf(document) {
    var styleSheet = document.documentElement;
    var numberFormats = [];
    var numFmts = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(styleSheet, 'numFmts');
    if (numFmts) return (0, $b77897ce6f4fce6e$export$f94ca194e830789c)(numFmts, 'numFmt');
    return [];
}
function $d7aca80854b84493$export$a993abd263855419(document) {
    // An `<si/>` element can contain a `<t/>` (simplest case) or a set of `<r/>` ("rich formatting") elements having `<t/>`.
    // https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sharedstringitem?redirectedfrom=MSDN&view=openxml-2.8.1
    // http://www.datypic.com/sc/ooxml/e-ssml_si-1.html
    var sst = document.documentElement;
    return (0, $b77897ce6f4fce6e$export$871de8747c9eaa88)(sst, 'si', function(string) {
        var t = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(string, 't');
        if (t) return t.textContent;
        var value = '';
        (0, $b77897ce6f4fce6e$export$4b80e395e36b5a56)(string, 'r', function(r) {
            value += (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(r, 't').textContent;
        });
        return value;
    });
}
function $d7aca80854b84493$export$9505db109aa0999b(document) {
    var workbook = document.documentElement;
    return (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(workbook, 'workbookPr');
}
function $d7aca80854b84493$export$ece9beb28e4eb24(document) {
    var relationships = document.documentElement;
    return (0, $b77897ce6f4fce6e$export$f94ca194e830789c)(relationships, 'Relationship');
}
function $d7aca80854b84493$export$432c3810533f8513(document) {
    var workbook = document.documentElement;
    var sheets = (0, $b77897ce6f4fce6e$export$8163adcb8ffddfe9)(workbook, 'sheets');
    return (0, $b77897ce6f4fce6e$export$f94ca194e830789c)(sheets, 'sheet');
}


function $59f0f1372825076e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $59f0f1372825076e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $59f0f1372825076e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $59f0f1372825076e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $59f0f1372825076e$var$_arrayLikeToArray(o, minLen);
}
function $59f0f1372825076e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $59f0f1372825076e$export$2e2bcd8739ae039(content, xml) {
    var book = xml.createDocument(content);
    // Read `<workbookPr/>` element to detect whether dates are 1900-based or 1904-based.
    // https://support.microsoft.com/en-gb/help/214330/differences-between-the-1900-and-the-1904-date-system-in-excel
    // http://webapp.docx4java.org/OnlineDemo/ecma376/SpreadsheetML/workbookPr.html
    var workbookProperties = (0, $d7aca80854b84493$export$9505db109aa0999b)(book);
    var epoch1904 = Boolean(workbookProperties) && workbookProperties.getAttribute('date1904') === '1';
    // Example of `<sheets/>` element:
    //
    // <sheets>
    //   <sheet
    //     xmlns:ns="http://schemas.openxmlformats.org/officeDocument/2006/relationships"
    //     name="Sheet1"
    //     sheetId="1"
    //     ns:id="rId3"/>
    // </sheets>
    var sheets = [];
    for(var _iterator = $59f0f1372825076e$var$_createForOfIteratorHelperLoose((0, $d7aca80854b84493$export$432c3810533f8513)(book)), _step; !(_step = _iterator()).done;){
        var sheet = _step.value;
        if (sheet.getAttribute('name')) sheets.push({
            id: sheet.getAttribute('sheetId'),
            name: sheet.getAttribute('name'),
            relationId: sheet.getAttribute('r:id')
        });
    }
    return {
        epoch1904: epoch1904,
        sheets: sheets
    };
}



function $4a3d1654250b7376$export$2e2bcd8739ae039(content, xml) {
    // Example:
    // <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    //   ...
    //   <Relationship
    //     Id="rId3"
    //     Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"
    //     Target="worksheets/sheet1.xml"/>
    // </Relationships>
    var document = xml.createDocument(content);
    var filePaths = {
        sheets: {},
        sharedStrings: undefined,
        styles: undefined
    };
    var addFilePathInfo = function addFilePathInfo(relationship) {
        var filePath = relationship.getAttribute('Target');
        var fileType = relationship.getAttribute('Type');
        switch(fileType){
            case 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles':
                filePaths.styles = $4a3d1654250b7376$var$getFilePath(filePath);
                break;
            case 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings':
                filePaths.sharedStrings = $4a3d1654250b7376$var$getFilePath(filePath);
                break;
            case 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet':
                filePaths.sheets[relationship.getAttribute('Id')] = $4a3d1654250b7376$var$getFilePath(filePath);
                break;
        }
    };
    (0, $d7aca80854b84493$export$ece9beb28e4eb24)(document).forEach(addFilePathInfo);
    // Seems like "sharedStrings.xml" is not required to exist.
    // For example, when the spreadsheet doesn't contain any strings.
    // https://github.com/catamphetamine/read-excel-file/issues/85
    // if (!filePaths.sharedStrings) {
    //   throw new Error('"sharedStrings.xml" file not found in the *.xlsx file')
    // }
    return filePaths;
}
function $4a3d1654250b7376$var$getFilePath(path) {
    // Normally, `path` is a relative path inside the ZIP archive,
    // like "worksheets/sheet1.xml", or "sharedStrings.xml", or "styles.xml".
    // There has been one weird case when file path was an absolute path,
    // like "/xl/worksheets/sheet1.xml" (specifically for sheets):
    // https://github.com/catamphetamine/read-excel-file/pull/95
    // Other libraries (like `xlsx`) and software (like Google Docs)
    // seem to support such absolute file paths, so this library does too.
    if (path[0] === '/') return path.slice(1);
    // // Seems like a path could also be a URL.
    // // http://officeopenxml.com/anatomyofOOXML-xlsx.php
    // if (/^[a-z]+\:\/\//.test(path)) {
    //   return path
    // }
    return 'xl/' + path;
}



function $9fa667eeebc01ab1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9fa667eeebc01ab1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9fa667eeebc01ab1$var$_typeof(o);
}
function $9fa667eeebc01ab1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9fa667eeebc01ab1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9fa667eeebc01ab1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9fa667eeebc01ab1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9fa667eeebc01ab1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9fa667eeebc01ab1$var$_defineProperty(obj, key, value) {
    key = $9fa667eeebc01ab1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9fa667eeebc01ab1$var$_toPropertyKey(arg) {
    var key = $9fa667eeebc01ab1$var$_toPrimitive(arg, "string");
    return $9fa667eeebc01ab1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9fa667eeebc01ab1$var$_toPrimitive(input, hint) {
    if ($9fa667eeebc01ab1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9fa667eeebc01ab1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9fa667eeebc01ab1$export$2e2bcd8739ae039(content, xml) {
    if (!content) return {};
    // https://social.msdn.microsoft.com/Forums/sqlserver/en-US/708978af-b598-45c4-a598-d3518a5a09f0/howwhen-is-cellstylexfs-vs-cellxfs-applied-to-a-cell?forum=os_binaryfile
    // https://www.office-forums.com/threads/cellxfs-cellstylexfs.2163519/
    var doc = xml.createDocument(content);
    var baseStyles = (0, $d7aca80854b84493$export$bff8031d86bb089)(doc).map($9fa667eeebc01ab1$var$parseCellStyle);
    var numberFormats = (0, $d7aca80854b84493$export$d23f63acf2d35cbf)(doc).map($9fa667eeebc01ab1$var$parseNumberFormatStyle).reduce(function(formats, format) {
        // Format ID is a numeric index.
        // There're some standard "built-in" formats (in Excel) up to about `100`.
        formats[format.id] = format;
        return formats;
    }, []);
    var getCellStyle = function getCellStyle(xf) {
        if (xf.hasAttribute('xfId')) return $9fa667eeebc01ab1$var$_objectSpread($9fa667eeebc01ab1$var$_objectSpread({}, baseStyles[xf.xfId]), $9fa667eeebc01ab1$var$parseCellStyle(xf, numberFormats));
        return $9fa667eeebc01ab1$var$parseCellStyle(xf, numberFormats);
    };
    return (0, $d7aca80854b84493$export$cbecc5fa687c7fad)(doc).map(getCellStyle);
}
function $9fa667eeebc01ab1$var$parseNumberFormatStyle(numFmt) {
    return {
        id: numFmt.getAttribute('numFmtId'),
        template: numFmt.getAttribute('formatCode')
    };
}
// http://www.datypic.com/sc/ooxml/e-ssml_xf-2.html
function $9fa667eeebc01ab1$var$parseCellStyle(xf, numFmts) {
    var style = {};
    if (xf.hasAttribute('numFmtId')) {
        var numberFormatId = xf.getAttribute('numFmtId');
        // Built-in number formats don't have a `<numFmt/>` element in `styles.xml`.
        // https://hexdocs.pm/xlsxir/number_styles.html
        if (numFmts[numberFormatId]) style.numberFormat = numFmts[numberFormatId];
        else style.numberFormat = {
            id: numberFormatId
        };
    }
    return style;
}



function $44df52109bf7e618$export$2e2bcd8739ae039(content, xml) {
    if (!content) return [];
    return (0, $d7aca80854b84493$export$a993abd263855419)(xml.createDocument(content));
}



// Parses an Excel Date (represented by a "serial" floating-point number)
// into a javascript `Date` in UTC+0 timezone (with time is set to 00:00).
//
// https://www.pcworld.com/article/3063622/software/mastering-excel-date-time-serial-numbers-networkdays-datevalue-and-more.html
// "If you need to calculate dates in your spreadsheets,
//  Excel uses its own unique system, which it calls Serial Numbers".
//
function $8eb06ea1d14cb334$export$2e2bcd8739ae039(excelSerialDate, options) {
    // Windows operating system uses floating-point numbers to represent dates,
    // where the number represents the count of days elapsed since January 0th, 1900.
    //
    // This also means that there're 2 aspects associated with this choice:
    //
    // * January 1st, 1900, 00:00 is represented by `1` rather than `0`, which looks a bit weird.
    // * 1900 is a special year because it's a "one in a 100 years" occasion when it's not a leap year.
    //
    // To work around those two aspects, Mac OS chose another baseline — January 1st, 1900.
    // Although, that only postponed the second issue because 2100 is going to be the next "speciaL" year
    // which is not going to be a "leap" one.
    //
    // Older versions of Excel on Mac OS used year 1904 as the default baseline for numeric dates.
    // Since 2011, Microsoft Excel on Mac OS uses year 1900 as the default baseline for cross-platform consistency.
    // https://support.microsoft.com/en-us/office/date-systems-in-excel-e7fe7167-48a9-4b96-bb53-5612a800b487
    //
    // So the 1904 baseline is now deprecated, although still available to be configured manually.
    // So it still might be encountered in Excel files created on MacOS.
    // In that case, the Excel file contains a special flag — `<workbook><workbookPr date1904="1"/>...` —
    // that tells the application which baseline is being used for numeric date timestamps.
    //
    if (options && options.epoch1904) // Convert the numeric date timestamp from 1904 baseline to 1900 baseline.
    excelSerialDate += 4 * $8eb06ea1d14cb334$var$DAYS_IN_YEAR + $8eb06ea1d14cb334$var$JANUARY_0TH_1900_DAY + $8eb06ea1d14cb334$var$ERRONEOUS_FEBRUARY_29_1990_DAY;
    var daysBeforeUnixEpoch = $8eb06ea1d14cb334$var$JANUARY_0TH_1900_DAY + $8eb06ea1d14cb334$var$ERRONEOUS_FEBRUARY_29_1990_DAY + 70 * $8eb06ea1d14cb334$var$DAYS_IN_YEAR + $8eb06ea1d14cb334$var$NUMBER_OF_LEAP_YEARS_BETWEEN_1900_AND_1970;
    return new Date(Math.floor((excelSerialDate - daysBeforeUnixEpoch) * $8eb06ea1d14cb334$var$DAY));
}
// "Excel serial date" is just a (fractional) count of days passed since `00/01/1900`.
//
// In contrast, "Unix timestamps" use `01/01/1970` as the baseline for numeric dates.
//
// In order to convert one into another, it should calculate the count of days elapsed
// since `00/01/1900` (Excel epoch) till `01/01/1970` (Unix epoch), or the count of days
// between year `1900` and year `1970`, plus one day.
//
// It also should account for the number of "leap years" between year `1900` and year `1970`,
// which is 17 of them. https://kalender-365.de/leap-years.php
//
// "One year has the length of 365 days, 5 hours, 48 minutes and 45 seconds.
//  These are 365.2421875 days. This is hard to calculate with, so for practical reasons
//  a normal year has been given 365 days and a leap year 366 days. In leap years,
//  February 29th is added as leap day, which doesn't exist in a normal year.
//  A leap year is every 4 years, but not every 100 years, then again every 400 years.
//  So the year 1900 wasn't a leap year, but 2000 was".
//
// And also, Excel has a historical bug when it incorrectly assumes year `1900` to be a leap year,
// and, as a result, all Excel serial dates starting from March 1st, 1900 lag 1 day behind
// and require an additional 1 day to be added to them in order to be converted to a proper timestamp.
//
// https://learn.microsoft.com/en-us/answers/questions/5249322/why-does-microsoft-excel-considers-29-02-1900-to-b?forum=msoffice-all&referrer=answers#:~:text=This%20made%20it%20easier%20for,other%20programs%20that%20use%20dates.
//
// "When Lotus 1-2-3 was first released, the program assumed that the year 1900 was a leap year,
//  even though it actually was not a leap year. This made it easier for the program to handle
//  leap years and caused no harm to almost all date calculations in Lotus 1-2-3.
//
//  When Microsoft Multiplan and Microsoft Excel were released, they also assumed that 1900
//  was a leap year. This assumption allowed Microsoft Multiplan and Microsoft Excel to use
//  the same serial date system used by Lotus 1-2-3 and provide greater compatibility with Lotus 1-2-3.
//  Treating 1900 as a leap year also made it easier for users to move worksheets from one program
//  to the other".
//
// So the historical bug is basically that Excel thinks that February 29th, 1900 existed
// while in reality it didn't. That's why it's actually 1 day off for any date after that one.
//
var $8eb06ea1d14cb334$var$NUMBER_OF_LEAP_YEARS_BETWEEN_1900_AND_1970 = 17;
var $8eb06ea1d14cb334$var$JANUARY_0TH_1900_DAY = 1;
var $8eb06ea1d14cb334$var$ERRONEOUS_FEBRUARY_29_1990_DAY = 1;
// An approximate count of seconds in a day is:
// 24 hours * 60 minutes in an hour * 60 seconds in a minute
//
// It is approximate because a minute could be longer than 60 seconds, due to "leap seconds".
//
// Still, javascript `Date`, and UNIX time in general, intentionally
// drop the concept of "leap seconds" in order to make things simpler.
// So this approximation is valid and doesn't result in any bugs.
// https://stackoverflow.com/questions/53019726/where-are-the-leap-seconds-in-javascript
//
// "The JavaScript Date object specifically adheres to the concept of Unix Time
//  (albeit with higher precision). This is part of the POSIX specification,
//  and thus is sometimes called "POSIX Time". It does not count leap seconds,
//  but rather assumes every day had exactly 86,400 seconds. You can read about
//  this in section 20.3.1.1 of the current ECMAScript specification, which states:
//
//  "Time is measured in ECMAScript in milliseconds since 01 January, 1970 UTC.
//   In time values leap seconds are ignored. It is assumed that there are exactly
//   86,400,000 milliseconds per day."
//
// The reason is that the unpredictable nature of leap seconds makes them very
// difficult to work with in APIs. One can't generally pass timestamps around
// that need leap seconds tables to be interpreted correctly, and expect that
// one system will interpret them the same as another. For example, a timestamp
// `1483228826` that accounts for "leap seconds" should've been interpreted as
// "2017-01-01T00:00:00Z", but if the receiver doesn't account for "leap seconds",
// they would interpret it as "2017-01-01T00:00:26Z" (e.g. POSIX-based systems like Linux),
// So "leap seconds" aren't really portable.
// Even on systems that have full frequently-updated "leap second" tables,
// there's no telling what adjustments those tables will contain in the future
// (i.e. beyond the 6-month IERS announcement period) because "leap seconds" can't be
// determined by a fixed mathematical formula or something like that. Instead,
// scientists introduce them as needed based on the observed Earth's rotation around the sun.
//
// "Because the Earth's rotational speed varies in response to climatic and geological events,
//  UTC leap seconds are irregularly spaced and not precisely predictable. The decision to insert
// a leap second is made by the International Earth Rotation and Reference Systems Service (IERS),
// typically about six months in advance, to ensure that the difference between UTC and UT1
// does not exceed ±0.9 seconds."
//
// One example is year `1900` which is "every fourth year" but it still is not a "leap year".
//
// To reiterate: to support leap seconds in a programming language, the implementation
// must go out of its way to do so, and must make tradeoffs that are not always acceptable.
// Though there are exceptions, the general position is to not support them - not because
// of any subversion or active countermeasures, but because supporting them properly is much,
// much harder.
//
// https://en.wikipedia.org/wiki/Unix_time#Leap_seconds
// https://en.wikipedia.org/wiki/Leap_year
// https://en.wikipedia.org/wiki/Leap_second
//
var $8eb06ea1d14cb334$var$DAY = 86400000;
var $8eb06ea1d14cb334$var$DAYS_IN_YEAR = 365;


// XLSX does have "d" type for dates, but it's not commonly used.
// Instead, it prefers using "n" type for storing dates as timestamps.
//
// Whether a numeric value is a number or a date timestamp, it sometimes could be
// detected by looking at the value "format" and seeing if it's a date-specific one.
function $068018f2a96782b1$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $068018f2a96782b1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $068018f2a96782b1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $068018f2a96782b1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $068018f2a96782b1$var$_arrayLikeToArray(o, minLen);
}
function $068018f2a96782b1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// On some date formats, there's a "[$-...]" prefix that locks the locale
// to be a specific one when formatting a date using this format.
//
// https://stackoverflow.com/questions/4730152/what-indicates-an-office-open-xml-cell-contains-a-date-time-value
//
// Format examples:
//
// * "[$-404]e/m/d"
// * "[$-414]mmmm\ yyyy;@"
// * "[$-ru-RU]dd.mm.yyyy;@"
// * "[$-x-sysdate]dddd, mmmm dd, yyyy"
//
var $068018f2a96782b1$var$DATE_FORMAT_SPECIFIC_LOCALE_PREFIX = /^\[\$-[^\]]+\]/;
// On some date formats, there's a ";@" suffix.
// It instructs the spreadsheet editor application to display any non-numeric
// value as is instead of hiding it or something like that.
//
// For example, if one inputs "Some text" instead of a date in such cell,
// it will still show "Some text" instead of an empty cell, even though
// the value is strictly-speaking invalid.
//
// Specifically, ";" means "anything before this applies only to a numeric value,
// while anything after it applies to a text value". And a follow-up "@" means
// "for a text value, just output it as is".
//
// It's not really clear why would anyone add such a feature to a format.
// Perhaps it feels more "user-friendly" towards a non-"tech-savvy" user
// of a spreadsheet editor application.
//
// Format examples:
//
// * "m/d/yyyy;@"
// * "[$-414]mmmm\ yyyy;@"
//
var $068018f2a96782b1$var$DATE_FORMAT_ALLOW_ANY_OTHER_TEXT_SUFFIX = /;@$/;
var $068018f2a96782b1$var$CACHE = {};
function $068018f2a96782b1$export$2e2bcd8739ae039(template) {
    if (template in $068018f2a96782b1$var$CACHE) return $068018f2a96782b1$var$CACHE[template];
    var result = $068018f2a96782b1$var$isDateFormat(template);
    $068018f2a96782b1$var$CACHE[template] = result;
    return result;
}
function $068018f2a96782b1$var$isDateFormat(template) {
    // Date format tokens could be in upper case or in lower case.
    // There seems to be no single standard.
    // So the template is lowercased first.
    template = template.toLowerCase();
    // On some date formats, there's an "[$-...]" prefix.
    // It forces a specific locale to be used when formatting a date.
    template = template.replace($068018f2a96782b1$var$DATE_FORMAT_SPECIFIC_LOCALE_PREFIX, '');
    // On some date formats, there's an ";@" suffix.
    // It's not clear why would anyone need it in a date format template.
    // Still, because it occurs there, it should be stripped.
    template = template.replace($068018f2a96782b1$var$DATE_FORMAT_ALLOW_ANY_OTHER_TEXT_SUFFIX, '');
    // Extract all alphabetic parts from what's left from the template string.
    // Example: "mm/dd/yyyy" → ["mm", "dd", "yyyy"]
    var tokens = template.split(/\W+/);
    // If no alphabetic parts are present in what's left from the template string
    // then it could be any kind of template such as a generic numeric template
    // such as "$#,##0.00" currency template or "0.0%" percentage template.
    if (tokens.length < 0) return false;
    for(var _iterator = $068018f2a96782b1$var$_createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        // If a non-date-format-specific alphabetic substring is found,
        // this might not necessarily be a date format.
        if ($068018f2a96782b1$var$DATE_TEMPLATE_TOKENS.indexOf(token) < 0) return false;
    }
    return true;
}
// These tokens could be in upper case or in lower case.
// There seems to be no single standard, so using lower case.
var $068018f2a96782b1$var$DATE_TEMPLATE_TOKENS = [
    // Seconds (min two digits). Example: "05".
    'ss',
    // Minutes (min two digits). Example: "05". Could also be "Months". Weird.
    'mm',
    // Hours. Example: "1".
    'h',
    // Hours (min two digits). Example: "01".
    'hh',
    // "AM" part of "AM/PM". Lowercased just in case.
    'am',
    // "PM" part of "AM/PM". Lowercased just in case.
    'pm',
    // Day. Example: "1"
    'd',
    // Day (min two digits). Example: "01"
    'dd',
    // Month (numeric). Example: "1".
    'm',
    // Month (numeric, min two digits). Example: "01". Could also be "Minutes". Weird.
    'mm',
    // Month (shortened month name). Example: "Jan".
    'mmm',
    // Month (full month name). Example: "January".
    'mmmm',
    // Two-digit year. Example: "20".
    'yy',
    // Full year. Example: "2020".
    'yyyy',
    // I don't have any idea what "e" means.
    // It's used in "built-in" XLSX formats:
    // * 27 '[$-404]e/m/d';
    // * 36 '[$-404]e/m/d';
    // * 50 '[$-404]e/m/d';
    // * 57 '[$-404]e/m/d';
    'e'
];


function $f797e6a588640bd6$export$2e2bcd8739ae039(styleId, styles, options) {
    if (styleId) {
        var style = styles[styleId];
        if (!style) throw new Error("Cell style not found: ".concat(styleId));
        if (!style.numberFormat) return false;
        if (// Whether it's a "number format" that's conventionally used for storing date timestamps.
        $f797e6a588640bd6$var$BUILT_IN_DATE_FORMAT_IDS.indexOf(Number(style.numberFormat.id)) >= 0 || // Whether it's a "number format" that uses a "formatting template"
        // that the developer is certain is a date formatting template.
        options.dateFormat && style.numberFormat.template === options.dateFormat || // Whether the "smart formatting template" feature is not disabled
        // and it has detected that it's a date formatting template by looking at it.
        options.smartDateParser !== false && style.numberFormat.template && (0, $068018f2a96782b1$export$2e2bcd8739ae039)(style.numberFormat.template)) return true;
    }
}
// Built-in formats have ID < 164.
// Some of those formats are intended to use when displaying dates.
//
// Depending on the "locale" used by the spreadsheet viewing application,
// different built-in format IDs might correspond to different templates.
// https://learn.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.numberingformat?view=openxml-2.8.1
//
// Here's a list of "locale"-independent built-in format IDs that're known to represent dates.
//
var $f797e6a588640bd6$var$LOCALE_INDEPENDENT_BUILT_IN_DATE_FORMAT_IDS = [
    14,
    // mm-dd-yy
    15,
    // d-mmm-yy
    16,
    // d-mmm
    17,
    // mmm-yy
    18,
    // h:mm AM/PM
    19,
    // h:mm:ss AM/PM
    20,
    // h:mm
    21,
    // h:mm:ss
    22,
    // m/d/yy h:mm
    45,
    // mm:ss
    46,
    // [h]:mm:ss
    47 // mmss.0
];
// "zh-tw" OR "zh-cn" locales.
// Language glyphs (aka "hieroglyphs") are not replaced with their respective unicode values here.
var $f797e6a588640bd6$var$MAINLAND_CHINESE_OR_TAIWANESE_LOCALE_BUILT_IN_DATE_FORMAT_IDS = [
    27,
    // [$-404]e/m/d OR yyyy"年"m"月"
    28,
    // [$-404]e"年"m"月"d"日" OR m"月"d"日"
    29,
    // [$-404]e"年"m"月"d"日" OR m"月"d"日"
    30,
    // m/d/yy OR m-d-yy
    31,
    // yyyy"年"m"月"d"日" OR yyyy"年"m"月"d"日"
    32,
    // hh"時"mm"分" OR h"时"mm"分"
    33,
    // hh"時"mm"分"ss"秒" OR h"时"mm"分"ss"秒"
    34,
    // 上午/下午hh"時"mm"分" OR 上午/下午h"时"mm"分"
    35,
    // 上午/下午hh"時"mm"分"ss"秒" OR 上午/下午h"时"mm"分"ss"秒"
    36,
    // [$-404]e/m/d OR yyyy"年"m"月"
    50,
    // [$-404]e/m/d OR yyyy"年"m"月"
    51,
    // [$-404]e"年"m"月"d"日" OR m"月"d"日"
    52,
    // 上午/下午hh"時"mm"分" OR yyyy"年"m"月"
    53,
    // 上午/下午hh"時"mm"分"ss"秒" OR m"月"d"日"
    54,
    // [$-404]e"年"m"月"d"日" OR m"月"d"日"
    55,
    // 上午/下午hh"時"mm"分" OR 上午/下午h"时"mm"分"
    56,
    // 上午/下午hh"時"mm"分"ss"秒" OR 上午/下午h"时"mm"分"ss"秒"
    57,
    // [$-404]e/m/d OR yyyy"年"m"月"
    58 // [$-404]e"年"m"月"d"日" OR m"月"d"日"
];
// "ja-jp" OR "ko-kr" locales.
// Language glyphs (aka "hieroglyphs") are not replaced with their respective unicode values here.
var $f797e6a588640bd6$var$JAPANESE_OR_KOREAN_LOCALE_BUILT_IN_DATE_FORMAT_IDS = [
    27,
    // [$-411]ge.m.d OR yyyy"年" mm"月" dd"日"
    28,
    // [$-411]ggge"年"m"月"d"日" OR mm-dd
    29,
    // [$-411]ggge"年"m"月"d"日" OR mm-dd
    30,
    // m/d/yy OR mm-dd-yy
    31,
    // yyyy"年"m"月"d"日" OR yyyy"년" mm"월" dd"일"
    32,
    // h"時"mm"分" OR h"시" mm"분"
    33,
    // h"時"mm"分"ss"秒" OR h"시" mm"분" ss"초"
    34,
    // yyyy"年"m"月" OR yyyy-mm-dd
    35,
    // m"月"d"日" OR yyyy-mm-dd
    36,
    // [$-411]ge.m.d OR yyyy"年" mm"月" dd"日"
    50,
    // [$-411]ge.m.d OR yyyy"年" mm"月" dd"日"
    51,
    // [$-411]ggge"年"m"月"d"日" OR mm-dd
    52,
    // yyyy"年"m"月" OR yyyy-mm-dd
    53,
    // m"月"d"日" OR yyyy-mm-dd
    54,
    // [$-411]ggge"年"m"月"d"日" OR mm-dd
    55,
    // yyyy"年"m"月" OR yyyy-mm-dd
    56,
    // m"月"d"日" OR yyyy-mm-dd
    57,
    // [$-411]ge.m.d OR yyyy"年" mm"月" dd"日"
    58 // [$-411]ggge"年"m"月"d"日" OR mm-dd
];
// "th-th" locale.
// Language glyphs (aka "hieroglyphs") are not replaced with their respective unicode values here.
var $f797e6a588640bd6$var$THAI_LOCALE_BUILT_IN_DATE_FORMAT_IDS = [
    71,
    // ว/ด/ปปปป
    72,
    // ว-ดดด-ปป
    73,
    // ว-ดดด
    74,
    // ดดด-ปป
    75,
    // ช:นน
    76,
    // ช:นน:ทท
    77,
    // ว/ด/ปปปป ช:นน
    78,
    // นน:ทท
    79,
    // [ช]:นน:ทท
    80,
    // นน:ทท.0
    81 // d/m/bb
];
// Start with language-agnostic date format IDs.
var $f797e6a588640bd6$var$BUILT_IN_DATE_FORMAT_IDS = $f797e6a588640bd6$var$LOCALE_INDEPENDENT_BUILT_IN_DATE_FORMAT_IDS.concat(// Add Mainland Chinese or Taiwanese date format IDs that haven't already been added.
$f797e6a588640bd6$var$MAINLAND_CHINESE_OR_TAIWANESE_LOCALE_BUILT_IN_DATE_FORMAT_IDS).concat(// Add Japanese or Korean date format IDs that haven't already been added.
$f797e6a588640bd6$var$JAPANESE_OR_KOREAN_LOCALE_BUILT_IN_DATE_FORMAT_IDS.filter(function(numberFormatId) {
    return $f797e6a588640bd6$var$MAINLAND_CHINESE_OR_TAIWANESE_LOCALE_BUILT_IN_DATE_FORMAT_IDS.indexOf(numberFormatId) < 0;
})).concat(// Add Thai date format IDs that haven't already been added.
$f797e6a588640bd6$var$THAI_LOCALE_BUILT_IN_DATE_FORMAT_IDS.filter(function(numberFormatId) {
    return $f797e6a588640bd6$var$MAINLAND_CHINESE_OR_TAIWANESE_LOCALE_BUILT_IN_DATE_FORMAT_IDS.indexOf(numberFormatId) < 0;
}).filter(function(numberFormatId) {
    return $f797e6a588640bd6$var$JAPANESE_OR_KOREAN_LOCALE_BUILT_IN_DATE_FORMAT_IDS.indexOf(numberFormatId) < 0;
}));


function $4f65d51743218aab$export$2e2bcd8739ae039(value, type, _ref) {
    var getInlineStringValue = _ref.getInlineStringValue, getInlineStringXml = _ref.getInlineStringXml, getStyleId = _ref.getStyleId, styles = _ref.styles, sharedStrings = _ref.sharedStrings, epoch1904 = _ref.epoch1904, options = _ref.options;
    if (!type) // Default cell type is "n" (numeric).
    // http://www.datypic.com/sc/ooxml/t-ssml_CT_Cell.html
    type = 'n';
    // Available Excel cell types:
    // https://github.com/SheetJS/sheetjs/blob/19620da30be2a7d7b9801938a0b9b1fd3c4c4b00/docbits/52_datatype.md
    //
    // Some other document (seems to be old):
    // http://webapp.docx4java.org/OnlineDemo/ecma376/SpreadsheetML/ST_CellType.html
    //
    switch(type){
        // XLSX tends to store all strings as "shared" (indexed) ones
        // using "s" cell type (for saving on strage space).
        // "str" cell type is then generally only used for storing
        // formula-pre-calculated cell values.
        case 'str':
            value = $4f65d51743218aab$var$parseString(value, options);
            break;
        // Sometimes, XLSX stores strings as "inline" strings rather than "shared" (indexed) ones.
        // Perhaps the specification doesn't force it to use one or another.
        // Example: `<sheetData><row r="1"><c r="A1" s="1" t="inlineStr"><is><t>Test 123</t></is></c></row></sheetData>`.
        case 'inlineStr':
            value = getInlineStringValue();
            if (value === undefined) throw new Error("Unsupported \"inline string\" cell value structure: ".concat(getInlineStringXml()));
            value = $4f65d51743218aab$var$parseString(value, options);
            break;
        // XLSX tends to store string values as "shared" (indexed) ones.
        // "Shared" strings is a way for an Excel editor to reduce
        // the file size by storing "commonly used" strings in a dictionary
        // and then referring to such strings by their index in that dictionary.
        // Example: `<sheetData><row r="1"><c r="A1" s="1" t="s"><v>0</v></c></row></sheetData>`.
        case 's':
            // If a cell has no value then there's no `<c/>` element for it.
            // If a `<c/>` element exists then it's not empty.
            // The `<v/>`alue is a key in the "shared strings" dictionary of the
            // XLSX file, so look it up in the `sharedStrings` dictionary by the numeric key.
            var sharedStringIndex = Number(value);
            if (isNaN(sharedStringIndex)) throw new Error("Invalid \"shared\" string index: ".concat(value));
            if (sharedStringIndex >= sharedStrings.length) throw new Error("An out-of-bounds \"shared\" string index: ".concat(value));
            value = sharedStrings[sharedStringIndex];
            value = $4f65d51743218aab$var$parseString(value, options);
            break;
        // Boolean (TRUE/FALSE) values are stored as either "1" or "0"
        // in cells of type "b".
        case 'b':
            if (value === '1') value = true;
            else if (value === '0') value = false;
            else throw new Error("Unsupported \"boolean\" cell value: ".concat(value));
            break;
        // XLSX specification seems to support cells of type "z":
        // blank "stub" cells that should be ignored by data processing utilities.
        case 'z':
            value = undefined;
            break;
        // XLSX specification also defines cells of type "e" containing a numeric "error" code.
        // It's not clear what that means though.
        // They also wrote: "and `w` property stores its common name".
        // It's unclear what they meant by that.
        case 'e':
            value = $4f65d51743218aab$var$decodeError(value);
            break;
        // XLSX supports date cells of type "d", though seems like it (almost?) never
        // uses it for storing dates, preferring "n" numeric timestamp cells instead.
        // The value of a "d" cell is supposedly a string in "ISO 8601" format.
        // I haven't seen an XLSX file having such cells.
        // Example: `<sheetData><row r="1"><c r="A1" s="1" t="d"><v>2021-06-10T00:47:45.700Z</v></c></row></sheetData>`.
        case 'd':
            if (value === undefined) break;
            var parsedDate = new Date(value);
            if (isNaN(parsedDate.valueOf())) throw new Error("Unsupported \"date\" cell value: ".concat(value));
            value = parsedDate;
            break;
        // Numeric cells have type "n".
        case 'n':
            if (value === undefined) break;
            // XLSX does have "d" type for dates, but it's not commonly used.
            // Instead, it prefers using "n" type for storing dates as timestamps.
            var styleId = getStyleId();
            if (styleId && (0, $f797e6a588640bd6$export$2e2bcd8739ae039)(styleId, styles, options)) {
                // Parse the number from string.
                value = $4f65d51743218aab$var$parseNumberDefault(value);
                // Parse the number as a date timestamp.
                value = (0, $8eb06ea1d14cb334$export$2e2bcd8739ae039)(value, {
                    epoch1904: epoch1904
                });
            } else {
                // Parse the number from string.
                // Supports custom parsing function to work around javascript number encoding precision issues.
                // https://gitlab.com/catamphetamine/read-excel-file/-/issues/85
                var parseNumber = options.parseNumber || $4f65d51743218aab$var$parseNumberDefault;
                value = parseNumber(value);
            }
            break;
        default:
            throw new TypeError("Cell type not supported: ".concat(type));
    }
    // Convert empty values to `null`.
    if (value === undefined) value = null;
    return value;
}
// Decodes numeric error code to a string code.
// https://github.com/SheetJS/sheetjs/blob/19620da30be2a7d7b9801938a0b9b1fd3c4c4b00/docbits/52_datatype.md
function $4f65d51743218aab$var$decodeError(errorCode) {
    // While the error values are determined by the application,
    // the following are some example error values that could be used:
    switch(errorCode){
        case 0x00:
            return '#NULL!';
        case 0x07:
            return '#DIV/0!';
        case 0x0F:
            return '#VALUE!';
        case 0x17:
            return '#REF!';
        case 0x1D:
            return '#NAME?';
        case 0x24:
            return '#NUM!';
        case 0x2A:
            return '#N/A';
        case 0x2B:
            return '#GETTING_DATA';
        default:
            // Such error code doesn't exist. I made it up.
            return "#ERROR_".concat(errorCode);
    }
}
function $4f65d51743218aab$var$parseString(value, options) {
    // In some weird cases, a developer might want to disable
    // the automatic trimming of all strings.
    // For example, leading spaces might express a tree-like hierarchy.
    // https://github.com/catamphetamine/read-excel-file/pull/106#issuecomment-1136062917
    if (options.trim !== false) value = value.trim();
    if (value === '') value = undefined;
    return value;
}
// Parses a number from string.
// Throws an error if the number couldn't be parsed.
// When parsing floating-point number, is affected by
// the javascript number encoding precision issues:
// https://www.youtube.com/watch?v=2gIxbTn7GSc
// https://www.avioconsulting.com/blog/overcoming-javascript-numeric-precision-issues
function $4f65d51743218aab$var$parseNumberDefault(stringifiedNumber) {
    var parsedNumber = Number(stringifiedNumber);
    if (isNaN(parsedNumber)) throw new Error("Invalid \"numeric\" cell value: ".concat(stringifiedNumber));
    return parsedNumber;
}


function $76360de4557fefb2$var$_slicedToArray(arr, i) {
    return $76360de4557fefb2$var$_arrayWithHoles(arr) || $76360de4557fefb2$var$_iterableToArrayLimit(arr, i) || $76360de4557fefb2$var$_unsupportedIterableToArray(arr, i) || $76360de4557fefb2$var$_nonIterableRest();
}
function $76360de4557fefb2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $76360de4557fefb2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $76360de4557fefb2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $76360de4557fefb2$var$_arrayLikeToArray(o, minLen);
}
function $76360de4557fefb2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $76360de4557fefb2$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $76360de4557fefb2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $76360de4557fefb2$export$2e2bcd8739ae039(coordinatesString) {
    // Coordinate examples: "AA2091", "R988", "B1".
    var _coordinatesString$sp = coordinatesString.split(/(\d+)/), _coordinatesString$sp2 = $76360de4557fefb2$var$_slicedToArray(_coordinatesString$sp, 2), column = _coordinatesString$sp2[0], row = _coordinatesString$sp2[1];
    return [
        // Row.
        Number(row),
        // Column.
        // It's not clear why would `column` ever be non-trimmed,
        // but if it was added here then perhaps it could hypothetically happen, or smth.
        $76360de4557fefb2$var$getColumnNumberFromColumnLetters(column.trim())
    ];
}
// Maps "A1"-like coordinates to `{ row, column }` numeric coordinates.
var $76360de4557fefb2$var$LETTERS = [
    "",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z"
];
// Converts a letter coordinate to a digit coordinate.
// Examples: "A" -> 1, "B" -> 2, "Z" -> 26, "AA" -> 27, etc.
function $76360de4557fefb2$var$getColumnNumberFromColumnLetters(columnLetters) {
    // `for ... of ...` would require Babel polyfill for iterating a string.
    var n = 0;
    var i = 0;
    while(i < columnLetters.length){
        n *= 26;
        n += $76360de4557fefb2$var$LETTERS.indexOf(columnLetters[i]);
        i++;
    }
    return n;
}




function $ed62b690367ebc67$export$2e2bcd8739ae039(element, sheetDocument, sharedStrings, styles, epoch1904, options) {
    var coordinates = (0, $76360de4557fefb2$export$2e2bcd8739ae039)(element.getAttribute('r'));
    var valueElement = (0, $d7aca80854b84493$export$96e987a410e855d8)(sheetDocument, element);
    // When the value element doesn't exist, it would be returned as `undefined`
    // when using `xpath` and as `null` when using `DOMParser`.
    // So here it uses `value && ...` syntax instead of `if (value !== undefined) { ... }`
    // for compatibility with both `xpath` and `DOMParser`.
    var value = valueElement && valueElement.textContent;
    var type = element.getAttribute('t');
    return {
        row: coordinates[0],
        column: coordinates[1],
        value: (0, $4f65d51743218aab$export$2e2bcd8739ae039)(value, type, {
            getInlineStringValue: function getInlineStringValue() {
                return (0, $d7aca80854b84493$export$78a3f2230f4dec6f)(sheetDocument, element);
            },
            getInlineStringXml: function getInlineStringXml() {
                return (0, $b77897ce6f4fce6e$export$441f600056df684b)(element);
            },
            getStyleId: function getStyleId() {
                return element.getAttribute('s');
            },
            styles: styles,
            sharedStrings: sharedStrings,
            epoch1904: epoch1904,
            options: options
        })
    };
}


function $15b3309850df6f3d$export$2e2bcd8739ae039(sheetDocument, sharedStrings, styles, epoch1904, options) {
    var cells = (0, $d7aca80854b84493$export$1c12da66f9764822)(sheetDocument);
    if (cells.length === 0) return [];
    // It seems like the idea of parsing "merged cells" was abandoned without being finished.
    // Here, it seems to just get to the stage of parsing merged cell coordinates.
    // Perhaps it's because it's not clear how would the package return merged cell results.
    // I.e. should it just duplicate the value in each one of the merged cells?
    // Or should it keep the existing behavior of only returning the value of the top-most left-most cell
    // and then return `null` for the other ones?
    // Perhaps the latter (existing) approach was found to be the most sensible.
    //
    // const mergedCells = getMergedCellCoordinates(sheetDocument)
    // for (const mergedCell of mergedCells) {
    //   const [from, to] = mergedCell.split(':').map(parseCellCoordinates)
    //   console.log('Merged Cell.', 'From:', from, 'To:', to)
    // }
    return cells.map(function(element) {
        return (0, $ed62b690367ebc67$export$2e2bcd8739ae039)(element, sheetDocument, sharedStrings, styles, epoch1904, options);
    });
}




function $f494ff55f87a25cb$var$_slicedToArray(arr, i) {
    return $f494ff55f87a25cb$var$_arrayWithHoles(arr) || $f494ff55f87a25cb$var$_iterableToArrayLimit(arr, i) || $f494ff55f87a25cb$var$_unsupportedIterableToArray(arr, i) || $f494ff55f87a25cb$var$_nonIterableRest();
}
function $f494ff55f87a25cb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f494ff55f87a25cb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f494ff55f87a25cb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f494ff55f87a25cb$var$_arrayLikeToArray(o, minLen);
}
function $f494ff55f87a25cb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f494ff55f87a25cb$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f494ff55f87a25cb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f494ff55f87a25cb$export$2e2bcd8739ae039(sheetDocument) {
    var dimensions = (0, $d7aca80854b84493$export$d1aa971bf69c7e87)(sheetDocument);
    if (dimensions) {
        dimensions = dimensions.split(':').map((0, $76360de4557fefb2$export$2e2bcd8739ae039)).map(function(_ref) {
            var _ref2 = $f494ff55f87a25cb$var$_slicedToArray(_ref, 2), row = _ref2[0], column = _ref2[1];
            return {
                row: row,
                column: column
            };
        });
        // Sometimes there can be just a single cell as a spreadsheet's "dimensions".
        // For example, the default "dimensions" in Apache POI library is "A1",
        // meaning that only the first cell in the spreadsheet is used.
        //
        // A quote from Apache POI library:
        // "Single cell ranges are formatted like single cell references (e.g. 'A1' instead of 'A1:A1')."
        //
        if (dimensions.length === 1) dimensions = [
            dimensions[0],
            dimensions[0]
        ];
        return dimensions;
    }
}


function $f62bba78d559710e$export$2e2bcd8739ae039(cells) {
    var comparator = function comparator(a, b) {
        return a - b;
    };
    var allRows = cells.map(function(cell) {
        return cell.row;
    }).sort(comparator);
    var allCols = cells.map(function(cell) {
        return cell.column;
    }).sort(comparator);
    var minRow = allRows[0];
    var maxRow = allRows[allRows.length - 1];
    var minCol = allCols[0];
    var maxCol = allCols[allCols.length - 1];
    return [
        {
            row: minRow,
            column: minCol
        },
        {
            row: maxRow,
            column: maxCol
        }
    ];
}


function $dd1b633b5be55a24$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $dd1b633b5be55a24$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dd1b633b5be55a24$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $dd1b633b5be55a24$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $dd1b633b5be55a24$var$_arrayLikeToArray(o, minLen);
}
function $dd1b633b5be55a24$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $dd1b633b5be55a24$export$2e2bcd8739ae039(data) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, rowIndexSourceMap = _ref.rowIndexSourceMap, _ref$accessor = _ref.accessor, accessor = _ref$accessor === void 0 ? function(_) {
        return _;
    } : _ref$accessor, onlyTrimAtTheEnd = _ref.onlyTrimAtTheEnd;
    // Drop empty rows.
    var i = data.length - 1;
    while(i >= 0){
        // Check if the row is empty.
        var empty = true;
        for(var _iterator = $dd1b633b5be55a24$var$_createForOfIteratorHelperLoose(data[i]), _step; !(_step = _iterator()).done;){
            var cell = _step.value;
            if (accessor(cell) !== null) {
                empty = false;
                break;
            }
        }
        // Remove the empty row.
        if (empty) {
            data.splice(i, 1);
            if (rowIndexSourceMap) rowIndexSourceMap.splice(i, 1);
        } else if (onlyTrimAtTheEnd) break;
        i--;
    }
    return data;
}


function $47db6baaa8a549f3$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $47db6baaa8a549f3$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $47db6baaa8a549f3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $47db6baaa8a549f3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $47db6baaa8a549f3$var$_arrayLikeToArray(o, minLen);
}
function $47db6baaa8a549f3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $47db6baaa8a549f3$export$2e2bcd8739ae039(data) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$accessor = _ref.accessor, accessor = _ref$accessor === void 0 ? function(_) {
        return _;
    } : _ref$accessor, onlyTrimAtTheEnd = _ref.onlyTrimAtTheEnd;
    var i = data[0].length - 1;
    while(i >= 0){
        var empty = true;
        for(var _iterator = $47db6baaa8a549f3$var$_createForOfIteratorHelperLoose(data), _step; !(_step = _iterator()).done;){
            var row = _step.value;
            if (accessor(row[i]) !== null) {
                empty = false;
                break;
            }
        }
        if (empty) {
            var j = 0;
            while(j < data.length){
                data[j].splice(i, 1);
                j++;
            }
        } else if (onlyTrimAtTheEnd) break;
        i--;
    }
    return data;
}


function $9e83d188285cdf9e$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9e83d188285cdf9e$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e83d188285cdf9e$var$_slicedToArray(arr, i) {
    return $9e83d188285cdf9e$var$_arrayWithHoles(arr) || $9e83d188285cdf9e$var$_iterableToArrayLimit(arr, i) || $9e83d188285cdf9e$var$_unsupportedIterableToArray(arr, i) || $9e83d188285cdf9e$var$_nonIterableRest();
}
function $9e83d188285cdf9e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9e83d188285cdf9e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9e83d188285cdf9e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e83d188285cdf9e$var$_arrayLikeToArray(o, minLen);
}
function $9e83d188285cdf9e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9e83d188285cdf9e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9e83d188285cdf9e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9e83d188285cdf9e$export$2e2bcd8739ae039(cells, dimensions) {
    // If the sheet is empty.
    if (cells.length === 0) return [];
    var _dimensions = $9e83d188285cdf9e$var$_slicedToArray(dimensions, 2), leftTop = _dimensions[0], rightBottom = _dimensions[1];
    // Don't discard empty rows or columns at the start of the spreadsheet,
    // even when the `*.xlsx` file itself tells that the content starts at an offset.
    // https://github.com/catamphetamine/read-excel-file/issues/102
    // const colsCount = (rightBottom.column - leftTop.column) + 1
    // const rowsCount = (rightBottom.row - leftTop.row) + 1
    var colsCount = rightBottom.column;
    var rowsCount = rightBottom.row;
    // Initialize spreadsheet data structure.
    var data = new Array(rowsCount);
    var i = 0;
    while(i < rowsCount){
        data[i] = new Array(colsCount);
        var j = 0;
        while(j < colsCount){
            data[i][j] = null;
            j++;
        }
        i++;
    }
    // Fill in spreadsheet `data`.
    // (this code implies that `cells` aren't necessarily sorted by row and column:
    //  maybe that's not correct, this piece code was initially copy-pasted
    //  from some other library that used `XPath`)
    for(var _iterator = $9e83d188285cdf9e$var$_createForOfIteratorHelperLoose(cells), _step; !(_step = _iterator()).done;){
        var cell = _step.value;
        // Don't discard empty rows or columns at the start of the spreadsheet,
        // even when the `*.xlsx` file itself tells that the content starts at an offset.
        // https://github.com/catamphetamine/read-excel-file/issues/102
        // const rowIndex = cell.row - leftTop.row
        // const columnIndex = cell.column - leftTop.column
        var rowIndex = cell.row - 1;
        var columnIndex = cell.column - 1;
        // Ignore the data in the cell if it's outside of the spreadsheet's "dimensions".
        if (columnIndex < colsCount && rowIndex < rowsCount) data[rowIndex][columnIndex] = cell.value;
    }
    // // Fill in the row map, if the row map was passed.
    // if (options.rowIndexSourceMap) {
    //   let i = 0
    //   while (i < data.length) {
    //     options.rowIndexSourceMap[i] = i
    //     i++
    //   }
    // }
    // Drop (discard) empty columns at the right side.
    // Drop (discard) empty rows at the bottom.
    data = (0, $dd1b633b5be55a24$export$2e2bcd8739ae039)((0, $47db6baaa8a549f3$export$2e2bcd8739ae039)(data, {
        onlyTrimAtTheEnd: true
    }), {
        onlyTrimAtTheEnd: true
    } // { onlyTrimAtTheEnd: true, rowIndexSourceMap: options.rowIndexSourceMap }
    );
    return data;
}


function $ac663049e40d2ed7$export$2e2bcd8739ae039(content, xml, sharedStrings, styles, epoch1904, options) {
    var sheetDocument = xml.createDocument(content);
    var cells = (0, $15b3309850df6f3d$export$2e2bcd8739ae039)(sheetDocument, sharedStrings, styles, epoch1904, options);
    // `dimensions` defines the spreadsheet area enclosing all non-empty cells.
    // https://docs.microsoft.com/en-us/dotnet/api/documentformat.openxml.spreadsheet.sheetdimension?view=openxml-2.8.1
    var dimensions = (0, $f494ff55f87a25cb$export$2e2bcd8739ae039)(sheetDocument) || (0, $f62bba78d559710e$export$2e2bcd8739ae039)(cells);
    return (0, $9e83d188285cdf9e$export$2e2bcd8739ae039)(cells, dimensions);
}


function $5029a0c0440e2efc$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $5029a0c0440e2efc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5029a0c0440e2efc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5029a0c0440e2efc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5029a0c0440e2efc$var$_arrayLikeToArray(o, minLen);
}
function $5029a0c0440e2efc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5029a0c0440e2efc$export$2e2bcd8739ae039(contents, xml) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var getFileContent = function getFileContent(filePath) {
        if (!contents[filePath]) throw new Error("\"".concat(filePath, "\" file not found inside the *.xlsx file zip archive"));
        return contents[filePath];
    };
    // Read the paths to certain files inside the `.xlsx` file, which is itself just a `.zip` archive.
    // These paths aren't standardized between different spreadsheet editors.
    // https://github.com/tidyverse/readxl/issues/104
    var filePaths = (0, $4a3d1654250b7376$export$2e2bcd8739ae039)(getFileContent('xl/_rels/workbook.xml.rels'), xml);
    // The usual file path for "shared strings" is "xl/sharedStrings.xml".
    var sharedStrings = filePaths.sharedStrings ? (0, $44df52109bf7e618$export$2e2bcd8739ae039)(getFileContent(filePaths.sharedStrings), xml) : [];
    // The usual file path for "styles" is "xl/styles.xml".
    var styles = filePaths.styles ? (0, $9fa667eeebc01ab1$export$2e2bcd8739ae039)(getFileContent(filePaths.styles), xml) : {};
    var _parseSpreadsheetInfo = (0, $59f0f1372825076e$export$2e2bcd8739ae039)(getFileContent('xl/workbook.xml'), xml), sheets = _parseSpreadsheetInfo.sheets, epoch1904 = _parseSpreadsheetInfo.epoch1904;
    var sheetIdsToRead = options.sheets && options.sheets.map(function(sheet) {
        return $5029a0c0440e2efc$var$getSheetId(sheet, sheets);
    });
    // Parse sheets data.
    var sheetsData = [];
    for(var _i = 0, _Object$keys = Object.keys(filePaths.sheets); _i < _Object$keys.length; _i++){
        var sheetId = _Object$keys[_i];
        if (sheetIdsToRead && !sheetIdsToRead.includes(sheetId)) continue;
        sheetsData.push({
            sheet: $5029a0c0440e2efc$var$getSheetNameById(sheetId, sheets),
            data: (0, $ac663049e40d2ed7$export$2e2bcd8739ae039)(getFileContent(filePaths.sheets[sheetId]), xml, sharedStrings, styles, epoch1904, options)
        });
    }
    // Return spreadsheet data.
    return sheetsData;
}
function $5029a0c0440e2efc$var$getSheetId(sheet, sheets) {
    if (typeof sheet === 'string') {
        for(var _iterator = $5029a0c0440e2efc$var$_createForOfIteratorHelperLoose(sheets), _step; !(_step = _iterator()).done;){
            var _sheet = _step.value;
            if (_sheet.name === sheet) return _sheet.relationId;
        }
        throw new Error("Sheet \"".concat(sheet, "\" not found. Available sheets: ").concat(sheets.map(function(_ref) {
            var name = _ref.name;
            return "\"".concat(name, "\"");
        }).join(', ')));
    } else {
        if (sheet <= sheets.length) return sheets[sheet - 1].relationId;
        throw new Error("Sheet number out of bounds: ".concat(sheet, ". Available sheets count: ").concat(sheets.length));
    }
}
function $5029a0c0440e2efc$var$getSheetNameById(sheetId, sheets) {
    for(var _iterator2 = $5029a0c0440e2efc$var$_createForOfIteratorHelperLoose(sheets), _step2; !(_step2 = _iterator2()).done;){
        var sheet = _step2.value;
        if (sheet.relationId === sheetId) return sheet.name;
    }
    throw new Error("Sheet ID not found: ".concat(sheetId));
}


function $c44f6617e79e2229$export$2e2bcd8739ae039(input, options) {
    return (0, $f1382763c1512ed2$export$2e2bcd8739ae039)(input).then(function(contents) {
        return (0, $5029a0c0440e2efc$export$2e2bcd8739ae039)(contents, (0, $afe0828da796b709$export$2e2bcd8739ae039), options);
    });
}


const $e73bf42412feb220$var$timelineElement = document.getElementById("timeline");
var $e73bf42412feb220$var$timeline;
var $e73bf42412feb220$var$timelineFiltered = [];
var $e73bf42412feb220$var$timelineBin = [];
var $e73bf42412feb220$var$testel = document.createElement("input");
$e73bf42412feb220$var$testel.setAttribute("type", "file");
$e73bf42412feb220$var$testel.addEventListener("change", async ()=>{
    console.log("NEW FILE");
    const data = await (0, $c44f6617e79e2229$export$2e2bcd8739ae039)($e73bf42412feb220$var$testel.files[0]);
    const enableTestFunction = document.getElementById("enableTestFunction");
    if (enableTestFunction.checked) {
        console.log(data);
        $e73bf42412feb220$var$runTests(data);
    }
    $e73bf42412feb220$var$timeline = $e73bf42412feb220$var$compileSheets(data);
    //console.log(timeline);
    // filters.time[0]=timeline[0].date;
    // filters.time[1]=timeline[timeline.length-1].date;
    document.getElementById("limitdate1").value = $e73bf42412feb220$var$formatSetDate($e73bf42412feb220$var$timeline[0].date);
    document.getElementById("limitdate2").value = $e73bf42412feb220$var$formatSetDate($e73bf42412feb220$var$timeline[$e73bf42412feb220$var$timeline.length - 1].date);
    $e73bf42412feb220$var$regenerateTimeline($e73bf42412feb220$var$timeline, document.getElementById("timeline"));
});
document.body.appendChild($e73bf42412feb220$var$testel);
function $e73bf42412feb220$var$formatLocDate(date) {
    if (date == null) return null;
    let ret = new Date();
    //console.log(date);
    ret.setUTCFullYear(date.slice(6, 10));
    ret.setUTCMonth(date.slice(3, 5));
    ret.setUTCDate(date.slice(0, 2));
    ret.setUTCHours(date.slice(11, 13));
    ret.setUTCMinutes(date.slice(14, 16));
    ret.setUTCSeconds(date.slice(17, 19));
    return ret;
}
function $e73bf42412feb220$var$formatYNToBinary(yn) {
    if (yn == "Yes") return true;
    return false;
}
function $e73bf42412feb220$var$formatSetDate(date) {
    //console.log(date);
    let month = (date.getMonth() + 1).toString();
    if (month.length == 1) month = "0" + month;
    let day = date.getDate().toString();
    if (day.length == 1) day = "0" + day;
    //console.log(date.getFullYear()+"-"+month+"-"+day);
    return date.getFullYear() + "-" + month + "-" + day;
}
// Just bubble sort this - we're at the 'just work' stage, not the 'work well' stage.
function $e73bf42412feb220$var$sortByDate(list) {
    while(true){
        let loop = false;
        for(let i = 1; i < list.length; i++)if (list[i].date < list[i - 1].date) {
            loop = true;
            let placeholder = list[i];
            list[i] = list[i - 1];
            list[i - 1] = placeholder;
        }
        if (!loop) break;
    }
    return list;
}
function $e73bf42412feb220$var$regenerateTimeline(list, el) {
    while(el.firstChild)el.removeChild(el.lastChild);
    let date1 = list[0].date;
    let date2 = list[list.length - 1].date;
    for(let i = 0; i < list.length; i++){
        let newel = document.createElement("div");
        newel.setAttribute("class", "marker");
        const elementWidth = 3; // Make dynamic later
        let timelineProgress = 100 * (list[i].date - date1) / (date2 - date1);
        newel.style.left = "calc(" + timelineProgress + "% - " + timelineProgress / 100 * elementWidth + "px)";
        newel.style.width = elementWidth + "px";
        newel.setAttribute("filtertype", list[i].type);
        // Stick basic details in dropdown
        let dropdown = document.createElement("div");
        dropdown.classList.add("dropdown");
        let listify = [
            [
                "type",
                list[i].type
            ],
            [
                "date",
                list[i].date
            ]
        ];
        for(let j = 0; j < listify.length; j++){
            let p = document.createElement("p");
            p.textContent = listify[j][0] + ": " + listify[j][1];
            dropdown.appendChild(p);
        }
        newel.appendChild(dropdown);
        // Put full info in 'itemdetails' div on click
        newel.addEventListener("click", (e)=>{
            $e73bf42412feb220$var$updateItemDetails(list[i]);
        });
        el.appendChild(newel);
    }
}
const $e73bf42412feb220$var$itemDetails = document.getElementById("itemdetails");
function $e73bf42412feb220$var$updateItemDetails(instance) {
    //console.log(instance.target);
    while($e73bf42412feb220$var$itemDetails.firstChild)$e73bf42412feb220$var$itemDetails.removeChild($e73bf42412feb220$var$itemDetails.lastChild);
    for(var i in instance){
        let newel = document.createElement("p");
        newel.textContent = i + ": " + instance[i];
        switch(i){
            case "date":
                newel.classList.add("contextable"); // For clarity
                newel.title = "Right-click to shift the timeline boundaries around this point!";
                newel.setAttribute("date", instance[i]);
                newel.addEventListener("contextmenu", (e)=>{
                    e.preventDefault();
                    let time = new Date(e.target.getAttribute("date"));
                    $e73bf42412feb220$var$updateTimeLimits(time);
                });
                break;
            case "source":
                if (instance.type != "Chat") break;
                newel.classList.add("contextable");
                newel.setAttribute("source", instance[i]);
                newel.addEventListener("contextmenu", (e)=>{
                    e.preventDefault();
                    document.getElementById("chatSource").value = e.target.getAttribute("source");
                    $e73bf42412feb220$var$regenerateFiltered();
                });
                break;
        }
        const itemDetailsSizeDropoff = 3000;
        if (newel.textContent.length > itemDetailsSizeDropoff) {
            let fontSize = 100 * itemDetailsSizeDropoff / newel.textContent.length;
            const minFontSize = 20;
            if (fontSize > minFontSize) newel.style.fontSize = fontSize + "%";
            else newel.style.fontSize = minFontSize + "%";
        }
        $e73bf42412feb220$var$itemDetails.appendChild(newel);
    }
}
document.getElementById("regenerate").addEventListener("click", $e73bf42412feb220$var$regenerateFiltered);
function $e73bf42412feb220$var$regenerateFiltered() {
    // Regenerate using timelineFiltered
    if ($e73bf42412feb220$var$timeline == undefined) {
        alert("Add a timeline file first!");
        return;
    }
    $e73bf42412feb220$var$timelineFiltered = $e73bf42412feb220$var$applyFilters($e73bf42412feb220$var$timeline, $e73bf42412feb220$var$compileFilters());
    $e73bf42412feb220$var$regenerateTimeline($e73bf42412feb220$var$timelineFiltered, $e73bf42412feb220$var$timelineElement);
}
function $e73bf42412feb220$var$updateTimeLimits(time) {
    const timelineLimitLower = document.getElementById("limitdate1");
    const timelineLimitUpper = document.getElementById("limitdate2");
    const timeDifferenceHours = 24;
    let newTimeLower = time;
    newTimeLower.setHours(time.getHours() - timeDifferenceHours);
    timelineLimitLower.value = $e73bf42412feb220$var$formatSetDate(newTimeLower);
    let newTimeUpper = time;
    newTimeUpper.setHours(time.getHours() + timeDifferenceHours);
    newTimeUpper.setDate(time.getDate() + 1); // Because limits are currently dates without time, offby1
    timelineLimitUpper.value = $e73bf42412feb220$var$formatSetDate(newTimeUpper);
    console.log("Adjusted timeline limits to surround time: " + time);
    $e73bf42412feb220$var$regenerateFiltered();
}
document.getElementById("reset").addEventListener("click", (e)=>{
    document.getElementById("limitdate1").value = $e73bf42412feb220$var$formatSetDate($e73bf42412feb220$var$timeline[0].date);
    document.getElementById("limitdate2").value = $e73bf42412feb220$var$formatSetDate($e73bf42412feb220$var$timeline[$e73bf42412feb220$var$timeline.length - 1].date);
    $e73bf42412feb220$var$regenerateFiltered();
});
// Looks like locations aren't quite as simple as picking one nearest the time
// On smart devices, available for latest and a select few times in device history
// On old devices, unavailable
/* 
When file uploaded:
- Display summary information (case/evidence number not relevant) in corner
- Organise sheet data into folders
- Organise folders into timeline, order by time ascending
- Filter out items from timeline that don't count

To make timeline visual:
- Clear old timeline
- Draw line between left/right sides
- Get times of earliest/latest events
- For each event
    - Calculate percentage through timeline
    - Use percentage for distance across visual
    - Place marker on distance
    - Colour marker according to type
    - Set onclick to expand/retract connected info
    - Set clicking info to add/remove info to filters if available



Start writeup on analysis and design chapters
Initial prototypes were mockups

Add dropdown to email sender/reciever /callno for all emails used in dataset
Filter by app asking for location (/time difference?)

Potential for creating a map of locations?
How to present details examined in selected/hovered markers left up to me

XRY used to develop Nokia phone data
XRY is quick whereas Cellebrite is more complex

Smartphones were extracted with Graykey (also used for bruteforcing phones)
Excel spreadsheets are then developed with cellebrite

ITERATION 4 

Before generating timeline, find whether the sheets are the correct ones
New format of sheetMap, use to store which sheet is which 
sheetMap {
    summary: 0,
    calls:3,
    emails:7,
    locations:null, <- points marked with null do not exist, therefore we can skip them
    webhist:2
}

Add paragraph to methodology about how it's being evaluated

options for evaluation <- give them, cognitive walkthrough, take notes
- test script, have them walk through specific tasks
- Give them it, questionnaire about usability, interview for what did or did not work

*/ //document.getElementById().getEventListener("contextmenu"){}
function $e73bf42412feb220$var$findSheetMap(list) {
    let ret = {
        summary: null,
        calls: null,
        chats: null,
        contacts: null,
        deviceInfo: null,
        users: null,
        emails: null,
        locations: null,
        searchedItems: null,
        webHistory: null,
        // These ones exclusive to the Nokia dataset
        nokiaCalls: null,
        nokiaSMS: null,
        // These ones exclusive to the old (Cellebrite) dataset
        appUsage: null,
        cookies: null,
        connectivity: null,
        events: null,
        notifications: null,
        downloads: null,
        uploads: null,
        apps: null,
        instantMessages: null,
        networkUsages: null,
        passwords: null,
        socialMedia: null,
        dictionary: null,
        bookmarks: null
    };
    for(let i = 0; i < list.length; i++)switch(list[i].sheet){
        case "Summary":
            ret.summary = i;
            break;
        case "Call Log":
            ret.calls = i;
            break;
        case "Chats":
            ret.chats = i;
            break;
        case "Contacts":
            ret.contacts = i;
            break;
        case "Device Info":
            ret.deviceInfo = i;
            break;
        case "Device Users":
            ret.users = i;
            break;
        case "Emails":
            ret.emails = i;
            break;
        case "Locations":
            ret.locations = i;
            break;
        case "Searched Items":
            ret.searchedItems = i;
            break;
        case "Web History":
            ret.webHistory = i;
            break;
        case "Calls":
            if (list[0].sheet == "Case") ret.nokiaCalls = i;
            break;
        case "Messages SMS":
            if (list[0].sheet == "Case") ret.nokiaSMS = i;
            break;
    }
    return ret;
}
// Don't care about [0], it's the title
// [1] is the names so use that to dynamic-ify
function $e73bf42412feb220$var$addSheetCall(list) {
    let map = {
        from: null,
        date: null,
        country: null,
        prefix: null,
        duration: null,
        direction: null,
        status: null,
        name: null,
        number: null
    };
    for(let i = 0; i < list[1].length; i++)switch(list[1][i]){
        case "Date":
            map.date = i;
            break;
        case "Parties":
            map.from = i;
            break;
        case "Source":
            map.name = i;
            break;
        case "Account":
            map.number = i;
            break;
        case "Direction":
            map.direction = i;
            break;
        case "Status":
            map.status = i;
            break;
        case "Country code":
            map.country = i;
            break;
        case "Duration":
            map.duration = i;
            break;
        case "International Prefix":
            map.prefix = i;
            break;
    }
    let ret = [];
    let skipped1 = [];
    for(let i = 2; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping call due to missing date: "+i);
            skipped1.push(i);
            continue;
        }
        let append = {
            country: list[i][map.country],
            prefix: list[i][map.prefix],
            from: list[i][map.from],
            date: list[i][map.date],
            duration: list[i][map.duration],
            direction: list[i][map.direction],
            status: list[i][map.status],
            name: list[i][map.name],
            number: list[i][map.number],
            type: "Call"
        };
        ret.push(append);
    }
    if (skipped1.length > 0) console.warn("Skipped calls due to missing date: " + skipped1);
    return ret;
}
function $e73bf42412feb220$var$addSheetEmail(list) {
    let map = {
        sender: null,
        reciever: null,
        cc: null,
        bcc: null,
        date: null,
        subject: null,
        body: null,
        read: null,
        source: null,
        folder: null
    };
    for(let i = 0; i < list[1].length; i++)switch(list[1][i]){
        case "Time":
            map.date = i;
            break;
        case "From":
            map.sender = i;
            break;
        case "To":
            map.reciever = i;
            break;
        case "CC":
            map.cc = i;
            break;
        case "BCC":
            map.bcc = i;
            break;
        case "Subject":
            map.subject = i;
            break;
        case "Body":
            map.body = i;
            break;
        case "Status":
            map.read = i;
            break;
        case "Source":
            map.source = i;
            break;
        case "Folder":
            map.folder = i;
            break;
    }
    let ret = [];
    let skipped1 = [];
    for(let i = 2; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping email due to missing date: "+i);
            skipped1.push(i);
            continue;
        }
        let append = {
            date: $e73bf42412feb220$var$formatLocDate(list[i][map.date]),
            sender: list[i][map.sender],
            reciever: list[i][map.reciever],
            cc: list[i][map.cc],
            bcc: list[i][map.bcc],
            subject: list[i][map.subject],
            body: list[i][map.body],
            read: list[i][map.read] == "Read",
            source: list[i][map.read],
            folder: list[i][map.folder],
            type: "Email"
        };
        ret.push(append);
    }
    if (skipped1.length > 0) console.warn("Skipped emails due to missing date: " + skipped1);
    return ret;
}
function $e73bf42412feb220$var$addSheetChat(list) {
    let map = {
        date: null,
        source: null,
        from: null,
        to: null,
        body: null,
        deleted: null,
        starred: null,
        carved: null
    };
    for(let i = 0; i < list[1].length; i++)switch(list[1][i]){
        case "Start Time: Time":
            map.date = i;
            break;
        case "Source":
            map.source = i;
            break;
        case "From":
            map.from = i;
            break;
        case "To":
            map.to = i;
            break;
        case "Body":
            map.body = i;
            break;
        case "Deleted - Instant Message":
            map.deleted = i;
            break;
        case "Starred message":
            map.starred = i;
            break;
        case "Message Carved":
            map.carved = i;
            break;
    }
    let ret = [];
    let skipped1 = [];
    for(let i = 2; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping chat message due to missing date: "+i);
            skipped1.push(i);
            continue;
        }
        let append = {
            date: $e73bf42412feb220$var$formatLocDate(list[i][map.date]),
            source: list[i][map.source],
            from: list[i][map.from],
            to: list[i][map.to],
            body: list[i][map.body],
            deleted: $e73bf42412feb220$var$formatYNToBinary(list[i][map.deleted]),
            starred: $e73bf42412feb220$var$formatYNToBinary(list[i][map.starred]),
            carved: $e73bf42412feb220$var$formatYNToBinary(list[i][map.carved]),
            type: "Chat"
        };
        ret.push(append);
    }
    if (skipped1.length > 0) console.warn("Skipped chat messages due to missing date: " + skipped1);
    return ret;
}
function $e73bf42412feb220$var$addSheetLocation(list) {
    let map = {
        date: null,
        postcode: null,
        category: null,
        latitude: null,
        longitude: null,
        deleted: null,
        address: null,
        source: null
    };
    for(let i = 0; i < list[1].length; i++)switch(list[1][i]){
        case "Address":
            map.address = i;
            break;
        case "Name":
            map.postcode = i;
        case "Time":
            map.date = i;
            break;
        case "Category":
            map.category = i;
            break;
        case "Latitude":
            map.latitude = i;
            break;
        case "Longitude":
            map.longitude = i;
            break;
        case "Deleted":
            map.deleted = i;
            break;
        case "Source":
            map.source = i;
            break;
    }
    let ret = [];
    let skipped1 = [];
    for(let i = 2; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping location due to missing date: "+(i-2));
            skipped1.push(i);
            continue;
        }
        let append = {
            date: $e73bf42412feb220$var$formatLocDate(list[i][map.date]),
            source: list[i][map.source],
            address: list[i][map.address],
            latitude: list[i][map.latitude],
            longitude: list[i][map.longitude],
            postcode: list[i][map.postcode],
            category: list[i][map.category],
            deleted: $e73bf42412feb220$var$formatYNToBinary(list[i][map.deleted]),
            type: "Location"
        };
        ret.push(append);
    }
    if (skipped1.length > 0) console.warn("Skipped locations due to missing date: " + skipped1);
    return ret;
}
function $e73bf42412feb220$var$addSheetWebHistory(list) {
    let map = {
        date: null,
        url: null,
        title: null,
        pattern: null,
        account: null,
        source: null,
        deleted: null,
        SID: null
    };
    for(let i = 0; i < list[1].length; i++)switch(list[1][i]){
        case "Title":
            map.title = i;
            break;
        case "URL":
            map.url = i;
            break;
        case "Last Visited-Time":
            map.date = i;
            break;
        case "Account":
            map.account = i;
            break;
        case "Source":
            map.source = i;
            break;
        case "Usage Pattern":
            map.pattern = i;
            break;
        case "Deleted":
            map.deleted = i;
            break;
        case "SID":
            map.SID = i;
            break;
    }
    let ret = [];
    let skipped1 = [];
    for(let i = 2; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping web event due to missing date: "+(i-2));
            skipped1.push(i);
            continue;
        }
        let append = {
            date: $e73bf42412feb220$var$formatLocDate(list[i][map.date]),
            url: list[i][map.url],
            title: list[i][map.title],
            pattern: list[i][map.pattern],
            account: list[i][map.account],
            source: list[i][map.source],
            SID: list[i][map.SID],
            deleted: $e73bf42412feb220$var$formatYNToBinary(list[i][map.deleted]),
            type: "Web History"
        };
        ret.push(append);
    }
    if (skipped1.length > 0) console.warn("Skipped web events due to missing date: " + skipped1);
    return ret;
}
function $e73bf42412feb220$var$addSheetNokiaCall(list) {
    let map = {
        date: null,
        callType: null,
        to: null,
        from: null,
        duration: null,
        direction: null
    };
    for(let i = 0; i < list[0].length; i++)switch(list[0][i]){
        case "Call Type":
            map.callType = i;
            break;
        case "Time":
            map.date = i;
            break;
        case "To":
            map.to = i;
            break;
        case "From":
            map.from = i;
            break;
        case "Duration":
            map.duration = i;
            break;
        case "Direction":
            map.direction = i;
            break;
    }
    let ret = [];
    let skipped1 = [];
    for(let i = 1; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping call due to missing date: "+i);
            skipped1.push(i);
            continue;
        }
        let append = {
            date: $e73bf42412feb220$var$formatLocDate(list[i][map.date]),
            callType: list[i][map.callType],
            to: list[i][map.to],
            from: list[i][map.from],
            duration: list[i][map.duration],
            direction: list[i][map.direction],
            type: "Burner Call"
        };
        ret.push(append);
    }
    if (skipped1.length > 0) console.warn("Skipped burner calls due to missing date: " + skipped1);
    return ret;
}
function $e73bf42412feb220$var$addSheetNokiaSMS(list) {
    let map = {
        date: null,
        direction: null,
        to: null,
        from: null,
        body: null,
        deleted: null
    };
    for(let i = 0; i < list[0].length; i++)switch(list[0][i]){
        case "Direction":
            map.direction = i;
            break;
        case "To":
            map.to = i;
            break;
        case "From":
            map.from = i;
            break;
        case "Time":
            map.date = i;
            break;
        case "Text":
            map.body = i;
            break;
        case "Deleted":
            map.deleted = i;
            break;
    }
    let ret = [];
    skipped = [];
    for(let i = 1; i < list.length; i++){
        if (!list[i][map.date]) {
            //console.warn("Skipping SMS message due to missing date: "+i);
            skipped.push(i);
            continue;
        }
        let append = {
            date: $e73bf42412feb220$var$formatLocDate(list[i][map.date]),
            deleted: $e73bf42412feb220$var$formatYNToBinary(list[i][map.deleted]),
            to: list[i][map.to],
            from: list[i][map.from],
            body: list[i][map.body],
            direction: list[i][map.direction],
            type: "Burner SMS"
        };
        ret.push(append);
    }
    if (skipped.length > 0) console.warn("Skipped burner messages due to missing date: " + skipped);
    return ret;
}
function $e73bf42412feb220$var$compileSheets(list) {
    let sheetMap = $e73bf42412feb220$var$findSheetMap(list);
    let ret = [];
    if (sheetMap.emails) ret = ret.concat($e73bf42412feb220$var$addSheetEmail(list[sheetMap.emails].data));
    if (sheetMap.calls) ret = ret.concat($e73bf42412feb220$var$addSheetCall(list[sheetMap.calls].data));
    if (sheetMap.chats) ret = ret.concat($e73bf42412feb220$var$addSheetChat(list[sheetMap.chats].data));
    if (sheetMap.locations) ret = ret.concat($e73bf42412feb220$var$addSheetLocation(list[sheetMap.locations].data));
    if (sheetMap.webHistory) ret = ret.concat($e73bf42412feb220$var$addSheetWebHistory(list[sheetMap.webHistory].data));
    if (sheetMap.nokiaCalls) ret = ret.concat($e73bf42412feb220$var$addSheetNokiaCall(list[sheetMap.nokiaCalls].data));
    if (sheetMap.nokiaSMS) ret = ret.concat($e73bf42412feb220$var$addSheetNokiaSMS(list[sheetMap.nokiaSMS].data));
    ret = $e73bf42412feb220$var$sortByDate(ret);
    return ret;
}
function $e73bf42412feb220$var$compileFilters() {
    let ret = {
        timeline: {
            limitLower: null,
            limitUpper: null
        },
        Call: {
            enabled: false,
            number: null
        },
        Email: {
            enabled: false,
            sender: null,
            reciever: null
        },
        Chat: {
            enabled: false,
            source: null,
            from: null,
            bodyText: null
        },
        Location: {
            enabled: false,
            source: null,
            timeVariance: null
        },
        "Web History": {
            enabled: false,
            source: null,
            url: null,
            onlyShowDeleted: false
        },
        "Last User Activity": {
            enabled: false
        },
        "Burner Call": {
            enabled: false
        },
        "Burner SMS": {
            enabled: false
        }
    };
    for (const i of filtertypes.children)if (i.checked) ret[i.getAttribute("filtertype")].enabled = true;
    const timelineLimitLower = document.getElementById("limitdate1");
    const timelineLimitUpper = document.getElementById("limitdate2");
    ret.timeline.limitLower = new Date(timelineLimitLower.value);
    ret.timeline.limitUpper = new Date(timelineLimitUpper.value);
    ret.timeline.limitUpper.setDate(ret.timeline.limitUpper.getDate() + 1); // Account for date input off-by-one
    if (ret["Email"].enabled) {
        const emailSender = document.getElementById("emailSender");
        const emailReciever = document.getElementById("emailReciever");
        if (emailSender.value != "") ret["Email"].sender = emailSender.value;
        if (emailReciever.value != "") ret["Email"].reciever = emailReciever.value;
    }
    if (ret["Call"].enabled) {
        const callNumber = document.getElementById("callNumber");
        if (callNumber.value != "") ret["Call"].number = callNumber.value;
    }
    if (ret["Chat"].enabled) {
        const chatSource = document.getElementById("chatSource");
        const chatBodyText = document.getElementById("chatBodyText");
        if (chatSource.value != "") ret["Chat"].source = chatSource.value;
        if (chatBodyText.value != "") ret["Chat"].bodyText = chatBodyText.value;
    }
    ret["Web History"].enabled;
    return ret;
}
function $e73bf42412feb220$var$applyFilters(timeline, filters) {
    let ret = [];
    for(let i = 0; i < timeline.length; i++){
        const item = timeline[i];
        if (filters[item.type].enabled && filters.timeline.limitLower <= item.date && filters.timeline.limitUpper >= item.date) {
            let push = false;
            switch(item.type){
                case "Email":
                    if (filters["Email"].sender != null && filters["Email"].sender != item.sender) break;
                    if (filters["Email"].reciever != null && filters["Email"].reciever != item.reciever) break;
                    push = true;
                    break;
                case "Call":
                    if (filters["Call"].number != null && filters["Call"].number != item.number) break;
                    push = true;
                    break;
                case "Chat":
                    if (filters["Chat"].source != null && filters["Chat"].source != item.source) break;
                    if (filters["Chat"].bodyText != null) {
                        if (item.body == null) break;
                        if (!item.body.includes(filters["Chat"].bodyText)) break;
                    }
                    push = true;
                    break;
                default:
                    push = true;
            }
            if (push) ret.push(item);
        }
    }
    return ret;
}
// We can't easily test automatically due to data requirements, but we can use a function after data is provided
function $e73bf42412feb220$var$runTests(list) {
    console.log("TEST BLOCK");
    let sheetMap = $e73bf42412feb220$var$findSheetMap(list);
    console.log(sheetMap);
    if (sheetMap.emails) {
        console.log("EMAILS");
        console.log($e73bf42412feb220$var$addSheetEmail(list[sheetMap.emails].data));
    }
    if (sheetMap.calls) {
        console.log("CALLS");
        console.log($e73bf42412feb220$var$addSheetCall(list[sheetMap.calls].data));
    }
    if (sheetMap.chats) {
        console.log("CHATS");
        console.log($e73bf42412feb220$var$addSheetChat(list[sheetMap.chats].data));
    }
    if (sheetMap.locations) {
        console.log("LOCATIONS");
        console.log($e73bf42412feb220$var$addSheetLocation(list[sheetMap.locations].data));
    }
    if (sheetMap.webHistory) {
        console.log("WEB HISTORY");
        console.log($e73bf42412feb220$var$addSheetWebHistory(list[sheetMap.webHistory].data));
    }
    if (sheetMap.nokiaCalls) {
        console.log("NOKIA CALLS");
        console.log($e73bf42412feb220$var$addSheetNokiaCall(list[sheetMap.nokiaCalls].data));
    }
    if (sheetMap.nokiaSMS) {
        console.log("NOKIA SMS");
        console.log($e73bf42412feb220$var$addSheetNokiaSMS(list[sheetMap.nokiaSMS].data));
    }
    console.log("WHOLE");
    let compiled = $e73bf42412feb220$var$compileSheets(list);
    console.log(compiled);
    console.log("FILTERS");
    let filt = $e73bf42412feb220$var$compileFilters();
    console.log(filt);
    console.log("FILTERED TIMELINE");
    console.log($e73bf42412feb220$var$applyFilters(compiled, filt));
    console.log("END TEST BLOCK");
}


//# sourceMappingURL=SimpleTimelineVisualisation.b484cceb.js.map
